var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2969_39905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 55
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0001,
    cy: 27.5,
    r: 26.8082,
    fill: "#00406A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2969_39905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57227 -2.58658C9.57227 -2.58658 12.4807 7.62284 13.2236 20.1212C13.9649 32.6196 9.38695 44.5003 10.0047 48.9547C10.6224 53.4091 12.8101 57.6782 12.8101 57.6782L23.0521 57.522C21.7412 53.2684 21.4341 48.198 22.2251 43.8191C22.5957 41.4684 28.3627 42.8445 31.2283 41.9316C34.044 41.0342 35.5574 39.4248 37.0056 36.7909C37.6319 35.6516 40.4613 30.9312 40.9281 30.4799C41.3948 30.0287 42.3642 28.9391 41.4068 28.227C37.3779 25.238 40.2005 20.4301 29.0628 10.9019C25.1112 7.5216 22.1633 2.56446 21.8442 -2.62776L9.57227 -2.58658Z",
    fill: "url(#paint0_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4067 28.227C37.3778 25.238 40.2004 20.4301 29.0627 10.9019C25.1111 7.5216 22.1632 2.56446 21.8441 -2.62776L15.5571 -2.60717C16.2538 0.134787 18.4123 9.62011 18.7418 20.322C19.0695 30.9587 15.2654 45.0631 15.8831 49.5999C16.3499 53.0179 17.7277 56.2197 18.3797 57.5924L23.052 57.5203C21.7411 53.2667 21.4597 48.6664 22.2507 44.2858C22.6214 41.9351 28.3627 42.8428 31.2264 41.9299C34.0422 41.0325 36.1664 39.514 37.6146 36.8801C38.2409 35.7408 40.4595 30.9295 40.9263 30.4782C41.393 30.0269 42.3624 28.9374 41.405 28.2253L41.4067 28.227Z",
    fill: "#FFE8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2845 28.0676C36.7121 25.4166 39.1812 21.1647 29.4368 12.7604C27.1204 12.4652 24.8623 14.4677 23.9271 17.0054C23.0589 19.3579 25.2621 21.8459 22.5527 25.3308C21.7617 26.3483 21.3568 27.419 21.6468 28.6613C21.923 29.8436 21.2864 34.6154 24.0284 39.5571C24.2755 40.0032 24.5483 40.4185 24.9018 40.7685C26.7206 40.971 29.526 40.8183 31.2127 40.2812C33.7213 39.4816 35.6156 38.1278 36.906 35.7805C37.4636 34.7664 39.442 30.4767 39.8573 30.0752C40.2742 29.6737 41.1373 28.7025 40.2828 28.0676H40.2845Z",
    fill: "url(#paint1_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6478 -2.67579C24.967 2.51472 27.5236 7.64516 31.477 11.0254C40.0049 18.3213 39.7904 22.8237 41.0172 25.89C41.1922 26.3275 41.3964 26.7342 41.659 27.1168C41.9627 27.5578 42.3402 27.9628 42.8429 28.342C43.102 28.5359 43.4297 28.7195 43.6356 28.9683C44.0492 29.471 43.8072 30.1505 43.3405 30.6018C42.8721 31.053 42.3865 31.132 41.8769 31.5335C41.7465 31.6364 41.4839 31.9178 41.3707 32.0362C40.9795 32.4446 40.6844 32.9439 40.4561 33.4707C40.3635 33.6835 40.2811 33.9031 40.2091 34.121C39.9053 35.039 38.3302 40.4732 33.44 42.5785C28.7316 44.605 24.4591 43.7144 24.2034 44.3939C22.8496 47.1325 24.1554 53.3919 25.4663 57.6456L22.9783 57.637C21.6674 53.3834 20.8317 48.1894 22.1667 44.0302C22.9629 41.839 28.3026 42.8445 31.1664 41.9317C33.9822 41.0343 36.2248 39.4162 37.673 36.7806C38.2993 35.6413 40.3995 30.9295 40.8662 30.4782C41.333 30.027 42.3024 28.9374 41.345 28.2253C37.3161 25.2363 40.1387 20.4284 29.001 10.9002C25.0494 7.52162 22.1272 2.35685 21.8081 -2.83365L24.6478 -2.67579Z",
    fill: "url(#paint2_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9646 23.6986C37.5789 25.1005 38.8555 26.1232 39.7169 27.3877C39.6688 27.5061 39.674 27.5765 39.5779 27.5816C39.2759 27.1355 38.9087 26.6448 38.5398 26.2536C38.2841 25.9825 38.0061 25.7302 37.7213 25.4883C37.3798 25.1983 36.4241 24.4073 35.3826 24.1688C35.5198 24.0178 35.6983 23.9183 35.8973 23.8668C36.0603 23.8239 36.2285 23.8222 36.3949 23.7999C36.5974 23.7724 36.7673 23.7553 36.9646 23.7003V23.6986Z",
    fill: "url(#paint3_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.549 24.4061C35.8351 24.4061 36.0671 24.1741 36.0671 23.8879C36.0671 23.6017 35.8351 23.3697 35.549 23.3697C35.2628 23.3697 35.0308 23.6017 35.0308 23.8879C35.0308 24.1741 35.2628 24.4061 35.549 24.4061Z",
    fill: "url(#paint4_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9196 22.482C36.2058 22.482 36.4378 22.25 36.4378 21.9638C36.4378 21.6776 36.2058 21.4456 35.9196 21.4456C35.6334 21.4456 35.4014 21.6776 35.4014 21.9638C35.4014 22.25 35.6334 22.482 35.9196 22.482Z",
    fill: "url(#paint5_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4196 22.9883C33.7057 22.9883 33.9378 22.7563 33.9378 22.4701C33.9378 22.184 33.7057 21.952 33.4196 21.952C33.1334 21.952 32.9014 22.184 32.9014 22.4701C32.9014 22.7563 33.1334 22.9883 33.4196 22.9883Z",
    fill: "url(#paint6_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8108 18.8446C33.8108 19.1312 33.5792 19.3628 33.2926 19.3628C33.0061 19.3628 32.7744 19.1312 32.7744 18.8446C32.7744 18.5581 33.0061 18.3264 33.2926 18.3264C33.5792 18.3264 33.8108 18.5581 33.8108 18.8446Z",
    fill: "url(#paint7_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4896 19.8035C32.7758 19.8035 33.0078 19.5715 33.0078 19.2853C33.0078 18.9992 32.7758 18.7672 32.4896 18.7672C32.2034 18.7672 31.9714 18.9992 31.9714 19.2853C31.9714 19.5715 32.2034 19.8035 32.4896 19.8035Z",
    fill: "url(#paint8_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0905 19.7969C34.3766 19.7969 34.6087 19.5649 34.6087 19.2787C34.6087 18.9925 34.3766 18.7605 34.0905 18.7605C33.8043 18.7605 33.5723 18.9925 33.5723 19.2787C33.5723 19.5649 33.8043 19.7969 34.0905 19.7969Z",
    fill: "url(#paint9_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.224 20.2143C33.5102 20.2143 33.7422 19.9823 33.7422 19.6961C33.7422 19.4099 33.5102 19.1779 33.224 19.1779C32.9378 19.1779 32.7058 19.4099 32.7058 19.6961C32.7058 19.9823 32.9378 20.2143 33.224 20.2143Z",
    fill: "url(#paint10_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3368 20.6123C32.623 20.6123 32.855 20.3803 32.855 20.0941C32.855 19.8079 32.623 19.5759 32.3368 19.5759C32.0506 19.5759 31.8186 19.8079 31.8186 20.0941C31.8186 20.3803 32.0506 20.6123 32.3368 20.6123Z",
    fill: "url(#paint11_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.113 20.0062C35.113 20.2927 34.8814 20.5244 34.5949 20.5244C34.3083 20.5244 34.0767 20.2927 34.0767 20.0062C34.0767 19.7196 34.3083 19.488 34.5949 19.488C34.8814 19.488 35.113 19.7196 35.113 20.0062Z",
    fill: "url(#paint12_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4336 20.1917C34.4336 20.4783 34.202 20.7099 33.9154 20.7099C33.6289 20.7099 33.3972 20.4783 33.3972 20.1917C33.3972 19.9052 33.6289 19.6735 33.9154 19.6735C34.202 19.6735 34.4336 19.9052 34.4336 20.1917Z",
    fill: "url(#paint13_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4088 21.566C32.695 21.566 32.927 21.334 32.927 21.0478C32.927 20.7616 32.695 20.5296 32.4088 20.5296C32.1226 20.5296 31.8906 20.7616 31.8906 21.0478C31.8906 21.334 32.1226 21.566 32.4088 21.566Z",
    fill: "url(#paint14_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4487 21.7534C33.4487 22.0399 33.2171 22.2716 32.9305 22.2716C32.644 22.2716 32.4124 22.0399 32.4124 21.7534C32.4124 21.4668 32.644 21.2352 32.9305 21.2352C33.2171 21.2352 33.4487 21.4668 33.4487 21.7534Z",
    fill: "url(#paint15_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1284 22.4442C35.1284 22.7308 34.8968 22.9624 34.6102 22.9624C34.3237 22.9624 34.092 22.7308 34.092 22.4442C34.092 22.1577 34.3237 21.926 34.6102 21.926C34.8968 21.926 35.1284 22.1577 35.1284 22.4442Z",
    fill: "url(#paint16_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0133 23.5409C34.2995 23.5409 34.5315 23.3089 34.5315 23.0227C34.5315 22.7365 34.2995 22.5045 34.0133 22.5045C33.7271 22.5045 33.4951 22.7365 33.4951 23.0227C33.4951 23.3089 33.7271 23.5409 34.0133 23.5409Z",
    fill: "url(#paint17_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1783 22.1735C35.4645 22.1735 35.6965 21.9415 35.6965 21.6553C35.6965 21.3691 35.4645 21.1371 35.1783 21.1371C34.8922 21.1371 34.6602 21.3691 34.6602 21.6553C34.6602 21.9415 34.8922 22.1735 35.1783 22.1735Z",
    fill: "url(#paint18_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.549 21.7617C35.8351 21.7617 36.0671 21.5297 36.0671 21.2435C36.0671 20.9573 35.8351 20.7253 35.549 20.7253C35.2628 20.7253 35.0308 20.9573 35.0308 21.2435C35.0308 21.5297 35.2628 21.7617 35.549 21.7617Z",
    fill: "url(#paint19_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4098 23.0844C35.696 23.0844 35.928 22.8524 35.928 22.5662C35.928 22.28 35.696 22.048 35.4098 22.048C35.1236 22.048 34.8916 22.28 34.8916 22.5662C34.8916 22.8524 35.1236 23.0844 35.4098 23.0844Z",
    fill: "url(#paint20_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.83 23.8571C35.1162 23.8571 35.3482 23.6251 35.3482 23.3389C35.3482 23.0527 35.1162 22.8207 34.83 22.8207C34.5438 22.8207 34.3118 23.0527 34.3118 23.3389C34.3118 23.6251 34.5438 23.8571 34.83 23.8571Z",
    fill: "url(#paint21_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2214 23.3542C36.2214 23.6407 35.9898 23.8724 35.7032 23.8724C35.4167 23.8724 35.1851 23.6407 35.1851 23.3542C35.1851 23.0676 35.4167 22.836 35.7032 22.836C35.9898 22.836 36.2214 23.0676 36.2214 23.3542Z",
    fill: "url(#paint22_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3297 23.3162C36.6159 23.3162 36.8479 23.0842 36.8479 22.798C36.8479 22.5118 36.6159 22.2798 36.3297 22.2798C36.0435 22.2798 35.8115 22.5118 35.8115 22.798C35.8115 23.0842 36.0435 23.3162 36.3297 23.3162Z",
    fill: "url(#paint23_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4618 24.2902C36.748 24.2902 36.98 24.0582 36.98 23.772C36.98 23.4858 36.748 23.2538 36.4618 23.2538C36.1756 23.2538 35.9436 23.4858 35.9436 23.772C35.9436 24.0582 36.1756 24.2902 36.4618 24.2902Z",
    fill: "url(#paint24_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6187 20.5725C33.6187 20.859 33.387 21.0907 33.1005 21.0907C32.8139 21.0907 32.5823 20.859 32.5823 20.5725C32.5823 20.2859 32.8139 20.0543 33.1005 20.0543C33.387 20.0543 33.6187 20.2859 33.6187 20.5725Z",
    fill: "url(#paint25_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4093 21.808C33.6955 21.808 33.9275 21.5759 33.9275 21.2898C33.9275 21.0036 33.6955 20.7716 33.4093 20.7716C33.1231 20.7716 32.8911 21.0036 32.8911 21.2898C32.8911 21.5759 33.1231 21.808 33.4093 21.808Z",
    fill: "url(#paint26_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7902 22.6798C34.0764 22.6798 34.3084 22.4478 34.3084 22.1616C34.3084 21.8754 34.0764 21.6434 33.7902 21.6434C33.504 21.6434 33.272 21.8754 33.272 22.1616C33.272 22.4478 33.504 22.6798 33.7902 22.6798Z",
    fill: "url(#paint27_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3704 20.7372C35.3704 21.0237 35.1387 21.2554 34.8522 21.2554C34.5656 21.2554 34.334 21.0237 34.334 20.7372C34.334 20.4506 34.5656 20.219 34.8522 20.219C35.1387 20.219 35.3704 20.4506 35.3704 20.7372Z",
    fill: "url(#paint28_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.866 21.5475C34.866 21.834 34.6343 22.0657 34.3478 22.0657C34.0612 22.0657 33.8296 21.834 33.8296 21.5475C33.8296 21.2609 34.0612 21.0293 34.3478 21.0293C34.6343 21.0293 34.866 21.2609 34.866 21.5475Z",
    fill: "url(#paint29_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0595 21.3942C34.3456 21.3942 34.5776 21.1622 34.5776 20.876C34.5776 20.5898 34.3456 20.3578 34.0595 20.3578C33.7733 20.3578 33.5413 20.5898 33.5413 20.876C33.5413 21.1622 33.7733 21.3942 34.0595 21.3942Z",
    fill: "url(#paint30_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.353 26.6858C34.353 26.6858 34.7545 27.5472 36.7038 28.1031C38.653 28.6608 39.2089 28.6453 39.2089 28.6453L39.2192 28.8049C39.2192 28.8049 33.8417 28.1803 32.6509 28.2507C33.1073 27.2143 34.353 26.6858 34.353 26.6858Z",
    fill: "url(#paint31_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4148 26.5192C34.4148 26.8058 34.1832 27.0374 33.8966 27.0374C33.6101 27.0374 33.3784 26.8058 33.3784 26.5192C33.3784 26.2327 33.6101 26.001 33.8966 26.001C34.1832 26.001 34.4148 26.2327 34.4148 26.5192Z",
    fill: "url(#paint32_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0245 28.4994C32.3107 28.4994 32.5427 28.2674 32.5427 27.9812C32.5427 27.695 32.3107 27.463 32.0245 27.463C31.7384 27.463 31.5063 27.695 31.5063 27.9812C31.5063 28.2674 31.7384 28.4994 32.0245 28.4994Z",
    fill: "url(#paint33_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3666 23.9116C29.6528 23.9116 29.8848 23.6796 29.8848 23.3934C29.8848 23.1072 29.6528 22.8752 29.3666 22.8752C29.0804 22.8752 28.8484 23.1072 28.8484 23.3934C28.8484 23.6796 29.0804 23.9116 29.3666 23.9116Z",
    fill: "url(#paint34_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5309 24.2715C28.8171 24.2715 29.0491 24.0395 29.0491 23.7533C29.0491 23.4671 28.8171 23.2351 28.5309 23.2351C28.2447 23.2351 28.0127 23.4671 28.0127 23.7533C28.0127 24.0395 28.2447 24.2715 28.5309 24.2715Z",
    fill: "url(#paint35_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8412 24.8708C28.1274 24.8708 28.3594 24.6388 28.3594 24.3527C28.3594 24.0665 28.1274 23.8345 27.8412 23.8345C27.555 23.8345 27.323 24.0665 27.323 24.3527C27.323 24.6388 27.555 24.8708 27.8412 24.8708Z",
    fill: "url(#paint36_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5206 25.2211C28.8068 25.2211 29.0388 24.9891 29.0388 24.7029C29.0388 24.4167 28.8068 24.1847 28.5206 24.1847C28.2344 24.1847 28.0024 24.4167 28.0024 24.7029C28.0024 24.9891 28.2344 25.2211 28.5206 25.2211Z",
    fill: "url(#paint37_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2946 24.7366C29.5808 24.7366 29.8128 24.5046 29.8128 24.2184C29.8128 23.9323 29.5808 23.7003 29.2946 23.7003C29.0084 23.7003 28.7764 23.9323 28.7764 24.2184C28.7764 24.5046 29.0084 24.7366 29.2946 24.7366Z",
    fill: "url(#paint38_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0736 25.1418C30.3598 25.1418 30.5918 24.9098 30.5918 24.6236C30.5918 24.3374 30.3598 24.1054 30.0736 24.1054C29.7874 24.1054 29.5554 24.3374 29.5554 24.6236C29.5554 24.9098 29.7874 25.1418 30.0736 25.1418Z",
    fill: "url(#paint39_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2533 25.6135C29.5395 25.6135 29.7715 25.3815 29.7715 25.0953C29.7715 24.8092 29.5395 24.5772 29.2533 24.5772C28.9671 24.5772 28.7351 24.8092 28.7351 25.0953C28.7351 25.3815 28.9671 25.6135 29.2533 25.6135Z",
    fill: "url(#paint40_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5759 25.9707C29.5759 26.2573 29.3443 26.4889 29.0577 26.4889C28.7712 26.4889 28.5396 26.2573 28.5396 25.9707C28.5396 25.6842 28.7712 25.4525 29.0577 25.4525C29.3443 25.4525 29.5759 25.6842 29.5759 25.9707Z",
    fill: "url(#paint41_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.099 27.3861C29.3852 27.3861 29.6172 27.1541 29.6172 26.868C29.6172 26.5818 29.3852 26.3498 29.099 26.3498C28.8128 26.3498 28.5808 26.5818 28.5808 26.868C28.5808 27.1541 28.8128 27.3861 29.099 27.3861Z",
    fill: "url(#paint42_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.945 26.9383C30.2311 26.9383 30.4631 26.7063 30.4631 26.4201C30.4631 26.1339 30.2311 25.9019 29.945 25.9019C29.6588 25.9019 29.4268 26.1339 29.4268 26.4201C29.4268 26.7063 29.6588 26.9383 29.945 26.9383Z",
    fill: "url(#paint43_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9196 24.665C31.2058 24.665 31.4378 24.433 31.4378 24.1468C31.4378 23.8606 31.2058 23.6286 30.9196 23.6286C30.6334 23.6286 30.4014 23.8606 30.4014 24.1468C30.4014 24.433 30.6334 24.665 30.9196 24.665Z",
    fill: "url(#paint44_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7636 25.1382C32.0497 25.1382 32.2817 24.9062 32.2817 24.62C32.2817 24.3339 32.0497 24.1019 31.7636 24.1019C31.4774 24.1019 31.2454 24.3339 31.2454 24.62C31.2454 24.9062 31.4774 25.1382 31.7636 25.1382Z",
    fill: "url(#paint45_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1016 25.6306C32.1016 25.9172 31.8699 26.1488 31.5834 26.1488C31.2968 26.1488 31.0652 25.9172 31.0652 25.6306C31.0652 25.3441 31.2968 25.1124 31.5834 25.1124C31.8699 25.1124 32.1016 25.3441 32.1016 25.6306Z",
    fill: "url(#paint46_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6021 27.1389C30.6021 27.4255 30.3704 27.6571 30.0839 27.6571C29.7973 27.6571 29.5657 27.4255 29.5657 27.1389C29.5657 26.8524 29.7973 26.6207 30.0839 26.6207C30.3704 26.6207 30.6021 26.8524 30.6021 27.1389Z",
    fill: "url(#paint47_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.88 27.712C31.1662 27.712 31.3982 27.48 31.3982 27.1938C31.3982 26.9076 31.1662 26.6756 30.88 26.6756C30.5938 26.6756 30.3618 26.9076 30.3618 27.1938C30.3618 27.48 30.5938 27.712 30.88 27.712Z",
    fill: "url(#paint48_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.148 26.5192C32.148 26.8058 31.9163 27.0374 31.6298 27.0374C31.3432 27.0374 31.1116 26.8058 31.1116 26.5192C31.1116 26.2327 31.3432 26.001 31.6298 26.001C31.9163 26.001 32.148 26.2327 32.148 26.5192Z",
    fill: "url(#paint49_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8601 25.4212C32.8601 25.7078 32.6285 25.9394 32.3419 25.9394C32.0554 25.9394 31.8237 25.7078 31.8237 25.4212C31.8237 25.1347 32.0554 24.903 32.3419 24.903C32.6285 24.903 32.8601 25.1347 32.8601 25.4212Z",
    fill: "url(#paint50_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4191 26.7751C32.7053 26.7751 32.9373 26.5431 32.9373 26.2569C32.9373 25.9707 32.7053 25.7387 32.4191 25.7387C32.1329 25.7387 31.9009 25.9707 31.9009 26.2569C31.9009 26.5431 32.1329 26.7751 32.4191 26.7751Z",
    fill: "url(#paint51_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8052 27.2014C32.8052 27.488 32.5735 27.7196 32.287 27.7196C32.0004 27.7196 31.7688 27.488 31.7688 27.2014C31.7688 26.9149 32.0004 26.6832 32.287 26.6832C32.5735 26.6832 32.8052 26.9149 32.8052 27.2014Z",
    fill: "url(#paint52_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1466 27.4477C33.4328 27.4477 33.6648 27.2157 33.6648 26.9295C33.6648 26.6433 33.4328 26.4113 33.1466 26.4113C32.8604 26.4113 32.6284 26.6433 32.6284 26.9295C32.6284 27.2157 32.8604 27.4477 33.1466 27.4477Z",
    fill: "url(#paint53_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1466 26.4737C33.4328 26.4737 33.6648 26.2417 33.6648 25.9555C33.6648 25.6693 33.4328 25.4373 33.1466 25.4373C32.8604 25.4373 32.6284 25.6693 32.6284 25.9555C32.6284 26.2417 32.8604 26.4737 33.1466 26.4737Z",
    fill: "url(#paint54_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6608 28.0434C31.947 28.0434 32.179 27.8114 32.179 27.5252C32.179 27.2391 31.947 27.0071 31.6608 27.0071C31.3746 27.0071 31.1426 27.2391 31.1426 27.5252C31.1426 27.8114 31.3746 28.0434 31.6608 28.0434Z",
    fill: "url(#paint55_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.891 28.2925C33.1772 28.2925 33.4092 28.0605 33.4092 27.7743C33.4092 27.4882 33.1772 27.2561 32.891 27.2561C32.6048 27.2561 32.3728 27.4882 32.3728 27.7743C32.3728 28.0605 32.6048 28.2925 32.891 28.2925Z",
    fill: "url(#paint56_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7643 28.0277C34.0505 28.0277 34.2825 27.7957 34.2825 27.5095C34.2825 27.2233 34.0505 26.9913 33.7643 26.9913C33.4781 26.9913 33.2461 27.2233 33.2461 27.5095C33.2461 27.7957 33.4781 28.0277 33.7643 28.0277Z",
    fill: "url(#paint57_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7324 27.9665C30.7324 28.253 30.5008 28.4847 30.2142 28.4847C29.9277 28.4847 29.696 28.253 29.696 27.9665C29.696 27.6799 29.9277 27.4483 30.2142 27.4483C30.5008 27.4483 30.7324 27.6799 30.7324 27.9665Z",
    fill: "url(#paint58_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0653 28.5701C31.3515 28.5701 31.5835 28.3381 31.5835 28.0519C31.5835 27.7657 31.3515 27.5337 31.0653 27.5337C30.7791 27.5337 30.5471 27.7657 30.5471 28.0519C30.5471 28.3381 30.7791 28.5701 31.0653 28.5701Z",
    fill: "url(#paint59_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9085 27.3331C28.9085 27.6196 28.6768 27.8513 28.3903 27.8513C28.1037 27.8513 27.8721 27.6196 27.8721 27.3331C27.8721 27.0465 28.1037 26.8149 28.3903 26.8149C28.6768 26.8149 28.9085 27.0465 28.9085 27.3331Z",
    fill: "url(#paint60_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8281 27.6335C29.8281 27.9201 29.5965 28.1517 29.3099 28.1517C29.0234 28.1517 28.7917 27.9201 28.7917 27.6335C28.7917 27.347 29.0234 27.1153 29.3099 27.1153C29.5965 27.1153 29.8281 27.347 29.8281 27.6335Z",
    fill: "url(#paint61_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.578 26.0111C30.8642 26.0111 31.0962 25.7791 31.0962 25.4929C31.0962 25.2067 30.8642 24.9747 30.578 24.9747C30.2918 24.9747 30.0598 25.2067 30.0598 25.4929C30.0598 25.7791 30.2918 26.0111 30.578 26.0111Z",
    fill: "url(#paint62_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1724 25.1777C28.1724 25.4643 27.9407 25.6959 27.6542 25.6959C27.3676 25.6959 27.136 25.4643 27.136 25.1777C27.136 24.8912 27.3676 24.6595 27.6542 24.6595C27.9407 24.6595 28.1724 24.8912 28.1724 25.1777Z",
    fill: "url(#paint63_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3405 26.127C28.6266 26.127 28.8587 25.895 28.8587 25.6088C28.8587 25.3226 28.6266 25.0906 28.3405 25.0906C28.0543 25.0906 27.8223 25.3226 27.8223 25.6088C27.8223 25.895 28.0543 26.127 28.3405 26.127Z",
    fill: "url(#paint64_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2531 27.0054C28.5392 27.0054 28.7712 26.7734 28.7712 26.4872C28.7712 26.201 28.5392 25.969 28.2531 25.969C27.9669 25.969 27.7349 26.201 27.7349 26.4872C27.7349 26.7734 27.9669 27.0054 28.2531 27.0054Z",
    fill: "url(#paint65_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9973 26.0531C27.9973 26.3396 27.7657 26.5713 27.4791 26.5713C27.1926 26.5713 26.9609 26.3396 26.9609 26.0531C26.9609 25.7665 27.1926 25.5349 27.4791 25.5349C27.7657 25.5349 27.9973 25.7665 27.9973 26.0531Z",
    fill: "url(#paint66_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1405 24.2105C30.4267 24.2105 30.6587 23.9785 30.6587 23.6923C30.6587 23.4061 30.4267 23.1741 30.1405 23.1741C29.8543 23.1741 29.6223 23.4061 29.6223 23.6923C29.6223 23.9785 29.8543 24.2105 30.1405 24.2105Z",
    fill: "url(#paint67_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.952 25.43C31.2382 25.43 31.4702 25.198 31.4702 24.9118C31.4702 24.6256 31.2382 24.3936 30.952 24.3936C30.6658 24.3936 30.4338 24.6256 30.4338 24.9118C30.4338 25.198 30.6658 25.43 30.952 25.43Z",
    fill: "url(#paint68_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3159 26.2808C31.3159 26.5674 31.0843 26.799 30.7977 26.799C30.5112 26.799 30.2795 26.5674 30.2795 26.2808C30.2795 25.9943 30.5112 25.7626 30.7977 25.7626C31.0843 25.7626 31.3159 25.9943 31.3159 26.2808Z",
    fill: "url(#paint69_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8832 26.1234C30.1694 26.1234 30.4014 25.8914 30.4014 25.6052C30.4014 25.319 30.1694 25.087 29.8832 25.087C29.597 25.087 29.365 25.319 29.365 25.6052C29.365 25.8914 29.597 26.1234 29.8832 26.1234Z",
    fill: "url(#paint70_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.844 20.6022C30.844 20.6022 30.7771 21.5511 32.2115 22.9838C33.6443 24.4166 39.588 28.2687 39.588 28.2687L39.5194 28.4128C39.5194 28.4128 31.5372 23.2618 28.5979 21.1444C29.5004 20.4598 30.8457 20.6022 30.8457 20.6022H30.844Z",
    fill: "url(#paint71_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9795 20.4888C30.8406 20.7393 30.5248 20.8286 30.2743 20.6896C30.0238 20.5506 29.9346 20.2349 30.0736 19.9844C30.2126 19.7338 30.5283 19.6446 30.7788 19.7836C31.0293 19.9226 31.1185 20.2383 30.9795 20.4888Z",
    fill: "url(#paint72_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6321 20.8574C28.4932 21.1079 28.1774 21.1971 27.9269 21.0581C27.6764 20.9191 27.5872 20.6034 27.7262 20.3529C27.8651 20.1024 28.1809 20.0132 28.4314 20.1522C28.6819 20.2911 28.7711 20.6069 28.6321 20.8574Z",
    fill: "url(#paint73_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5377 15.5558C28.3987 15.8063 28.0829 15.8956 27.8324 15.7566C27.5819 15.6176 27.4927 15.3019 27.6317 15.0514C27.7707 14.8008 28.0864 14.7116 28.3369 14.8506C28.5874 14.9896 28.6766 15.3053 28.5377 15.5558Z",
    fill: "url(#paint74_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6316 15.4648C27.4927 15.7153 27.1769 15.8046 26.9264 15.6656C26.6759 15.5266 26.5867 15.2109 26.7257 14.9604C26.8647 14.7098 27.1804 14.6206 27.4309 14.7596C27.6814 14.8986 27.7706 15.2143 27.6316 15.4648Z",
    fill: "url(#paint75_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7378 15.6514C26.5989 15.9019 26.2831 15.9911 26.0326 15.8521C25.7821 15.7132 25.6929 15.3974 25.8319 15.1469C25.9709 14.8964 26.2866 14.8072 26.5371 14.9462C26.7876 15.0851 26.8768 15.4009 26.7378 15.6514Z",
    fill: "url(#paint76_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1617 16.2904C27.0227 16.5409 26.707 16.6301 26.4565 16.4911C26.2059 16.3521 26.1167 16.0364 26.2557 15.7859C26.3947 15.5354 26.7104 15.4462 26.9609 15.5852C27.2114 15.7241 27.3007 16.0399 27.1617 16.2904Z",
    fill: "url(#paint77_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0728 16.2421C27.9338 16.4926 27.6181 16.5818 27.3676 16.4428C27.1171 16.3038 27.0278 15.9881 27.1668 15.7376C27.3058 15.4871 27.6215 15.3979 27.8721 15.5369C28.1226 15.6758 28.2118 15.9916 28.0728 16.2421Z",
    fill: "url(#paint78_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5584 16.9731C28.4194 17.2236 28.1037 17.3128 27.8532 17.1738C27.6027 17.0349 27.5134 16.7191 27.6524 16.4686C27.7914 16.2181 28.1071 16.1289 28.3576 16.2679C28.6082 16.4069 28.6974 16.7226 28.5584 16.9731Z",
    fill: "url(#paint79_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6111 16.9883C27.4722 17.2389 27.1564 17.3281 26.9059 17.1891C26.6554 17.0501 26.5662 16.7344 26.7052 16.4839C26.8441 16.2334 27.1599 16.1441 27.4104 16.2831C27.6609 16.4221 27.7501 16.7378 27.6111 16.9883Z",
    fill: "url(#paint80_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.014 17.6599C26.875 17.9104 26.5593 17.9996 26.3087 17.8606C26.0582 17.7216 25.969 17.4059 26.108 17.1554C26.247 16.9049 26.5627 16.8157 26.8132 16.9546C27.0637 17.0936 27.153 17.4093 27.014 17.6599Z",
    fill: "url(#paint81_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.616 18.462C26.477 18.7126 26.1613 18.8018 25.9108 18.6628C25.6603 18.5238 25.5711 18.2081 25.71 17.9576C25.849 17.7071 26.1647 17.6178 26.4153 17.7568C26.6658 17.8958 26.755 18.2115 26.616 18.462Z",
    fill: "url(#paint82_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5718 18.4814C27.4328 18.7319 27.1171 18.8211 26.8666 18.6821C26.6161 18.5431 26.5269 18.2274 26.6659 17.9769C26.8048 17.7264 27.1206 17.6371 27.3711 17.7761C27.6216 17.9151 27.7108 18.2308 27.5718 18.4814Z",
    fill: "url(#paint83_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5279 16.966C29.3889 17.2165 29.0732 17.3057 28.8227 17.1667C28.5721 17.0277 28.4829 16.712 28.6219 16.4615C28.7609 16.211 29.0766 16.1218 29.3271 16.2607C29.5776 16.3997 29.6669 16.7155 29.5279 16.966Z",
    fill: "url(#paint84_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0374 17.7915C29.8984 18.042 29.5827 18.1313 29.3322 17.9923C29.0817 17.8533 28.9924 17.5376 29.1314 17.2871C29.2704 17.0365 29.5861 16.9473 29.8367 17.0863C30.0872 17.2253 30.1764 17.541 30.0374 17.7915Z",
    fill: "url(#paint85_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3887 18.5876C29.2497 18.8381 28.934 18.9273 28.6835 18.7884C28.433 18.6494 28.3438 18.3337 28.4827 18.0831C28.6217 17.8326 28.9375 17.7434 29.188 17.8824C29.4385 18.0214 29.5277 18.3371 29.3887 18.5876Z",
    fill: "url(#paint86_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3453 19.1783C27.2063 19.4288 26.8906 19.518 26.64 19.3791C26.3895 19.2401 26.3003 18.9243 26.4393 18.6738C26.5783 18.4233 26.894 18.3341 27.1445 18.4731C27.395 18.6121 27.4843 18.9278 27.3453 19.1783Z",
    fill: "url(#paint87_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0145 19.6124C27.8755 19.8629 27.5598 19.9522 27.3092 19.8132C27.0587 19.6742 26.9695 19.3585 27.1085 19.108C27.2475 18.8574 27.5632 18.7682 27.8137 18.9072C28.0642 19.0462 28.1534 19.3619 28.0145 19.6124Z",
    fill: "url(#paint88_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9976 19.3877C28.8586 19.6383 28.5429 19.7275 28.2924 19.5885C28.0419 19.4495 27.9527 19.1338 28.0916 18.8833C28.2306 18.6328 28.5463 18.5435 28.7969 18.6825C29.0474 18.8215 29.1366 19.1372 28.9976 19.3877Z",
    fill: "url(#paint89_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1524 18.7726C30.0134 19.0232 29.6977 19.1124 29.4472 18.9734C29.1967 18.8344 29.1074 18.5187 29.2464 18.2682C29.3854 18.0177 29.7011 17.9284 29.9516 18.0674C30.2022 18.2064 30.2914 18.5221 30.1524 18.7726Z",
    fill: "url(#paint90_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8143 19.5418C29.6753 19.7923 29.3596 19.8815 29.109 19.7425C28.8585 19.6035 28.7693 19.2878 28.9083 19.0373C29.0473 18.7868 29.363 18.6976 29.6135 18.8365C29.864 18.9755 29.9533 19.2913 29.8143 19.5418Z",
    fill: "url(#paint91_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2413 20.3017C29.1023 20.5523 28.7866 20.6415 28.536 20.5025C28.2855 20.3635 28.1963 20.0478 28.3353 19.7973C28.4743 19.5468 28.79 19.4575 29.0405 19.5965C29.291 19.7355 29.3803 20.0512 29.2413 20.3017Z",
    fill: "url(#paint92_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1231 20.4822C29.9841 20.7327 29.6684 20.8219 29.4179 20.683C29.1674 20.544 29.0781 20.2283 29.2171 19.9777C29.3561 19.7272 29.6718 19.638 29.9223 19.777C30.1729 19.916 30.2621 20.2317 30.1231 20.4822Z",
    fill: "url(#paint93_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5967 19.6307C30.4578 19.8812 30.142 19.9705 29.8915 19.8315C29.641 19.6925 29.5518 19.3768 29.6908 19.1263C29.8297 18.8757 30.1455 18.7865 30.396 18.9255C30.6465 19.0645 30.7357 19.3802 30.5967 19.6307Z",
    fill: "url(#paint94_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5359 20.2829C28.397 20.5335 28.0812 20.6227 27.8307 20.4837C27.5802 20.3447 27.491 20.029 27.63 19.7785C27.769 19.528 28.0847 19.4387 28.3352 19.5777C28.5857 19.7167 28.6749 20.0324 28.5359 20.2829Z",
    fill: "url(#paint95_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4918 21.0963C29.3528 21.3468 29.0371 21.436 28.7865 21.2971C28.536 21.1581 28.4468 20.8423 28.5858 20.5918C28.7248 20.3413 29.0405 20.2521 29.291 20.3911C29.5415 20.5301 29.6307 20.8458 29.4918 21.0963Z",
    fill: "url(#paint96_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3824 21.2905C30.2434 21.541 29.9277 21.6302 29.6772 21.4912C29.4266 21.3523 29.3374 21.0365 29.4764 20.786C29.6154 20.5355 29.9311 20.4463 30.1816 20.5853C30.4321 20.7242 30.5214 21.04 30.3824 21.2905Z",
    fill: "url(#paint97_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0587 19.9652C26.9197 20.2157 26.6039 20.305 26.3534 20.166C26.1029 20.027 26.0137 19.7113 26.1527 19.4608C26.2917 19.2102 26.6074 19.121 26.8579 19.26C27.1084 19.399 27.1976 19.7147 27.0587 19.9652Z",
    fill: "url(#paint98_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7606 20.4527C27.6216 20.7032 27.3058 20.7925 27.0553 20.6535C26.8048 20.5145 26.7156 20.1988 26.8546 19.9483C26.9936 19.6977 27.3093 19.6085 27.5598 19.7475C27.8103 19.8865 27.8995 20.2022 27.7606 20.4527Z",
    fill: "url(#paint99_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7701 18.5241C25.6311 18.7746 25.3154 18.8638 25.0649 18.7248C24.8143 18.5858 24.7251 18.2701 24.8641 18.0196C25.0031 17.7691 25.3188 17.6798 25.5693 17.8188C25.8198 17.9578 25.9091 18.2735 25.7701 18.5241Z",
    fill: "url(#paint100_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.429 19.2342C26.29 19.4847 25.9743 19.574 25.7238 19.435C25.4733 19.296 25.384 18.9803 25.523 18.7297C25.662 18.4792 25.9777 18.39 26.2283 18.529C26.4788 18.668 26.568 18.9837 26.429 19.2342Z",
    fill: "url(#paint101_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5755 17.9806C28.4365 18.2312 28.1208 18.3204 27.8703 18.1814C27.6198 18.0424 27.5305 17.7267 27.6695 17.4762C27.8085 17.2257 28.1242 17.1364 28.3747 17.2754C28.6253 17.4144 28.7145 17.7301 28.5755 17.9806Z",
    fill: "url(#paint102_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1751 16.2833C26.0361 16.5338 25.7204 16.623 25.4699 16.484C25.2194 16.345 25.1301 16.0293 25.2691 15.7788C25.4081 15.5283 25.7238 15.4391 25.9743 15.578C26.2249 15.717 26.3141 16.0327 26.1751 16.2833Z",
    fill: "url(#paint103_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5645 16.9934C26.4255 17.2439 26.1098 17.3332 25.8593 17.1942C25.6088 17.0552 25.5195 16.7395 25.6585 16.489C25.7975 16.2384 26.1132 16.1492 26.3638 16.2882C26.6143 16.4272 26.7035 16.7429 26.5645 16.9934Z",
    fill: "url(#paint104_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0618 17.7198C25.9228 17.9704 25.6071 18.0596 25.3566 17.9206C25.1061 17.7816 25.0169 17.4659 25.1558 17.2154C25.2948 16.9649 25.6106 16.8756 25.8611 17.0146C26.1116 17.1536 26.2008 17.4693 26.0618 17.7198Z",
    fill: "url(#paint105_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.595 16.9644C25.456 17.215 25.1403 17.3042 24.8898 17.1652C24.6393 17.0262 24.5501 16.7105 24.689 16.46C24.828 16.2095 25.1438 16.1202 25.3943 16.2592C25.6448 16.3982 25.734 16.7139 25.595 16.9644Z",
    fill: "url(#paint106_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0679 16.1923C28.9289 16.4428 28.6132 16.532 28.3627 16.393C28.1122 16.254 28.023 15.9383 28.1619 15.6878C28.3009 15.4373 28.6167 15.3481 28.8672 15.487C29.1177 15.626 29.2069 15.9417 29.0679 16.1923Z",
    fill: "url(#paint107_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1863 17.6527C29.0473 17.9033 28.7316 17.9925 28.4811 17.8535C28.2306 17.7145 28.1414 17.3988 28.2804 17.1483C28.4193 16.8978 28.7351 16.8085 28.9856 16.9475C29.2361 17.0865 29.3253 17.4022 29.1863 17.6527Z",
    fill: "url(#paint108_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4175 18.7914C28.2786 19.042 27.9628 19.1312 27.7123 18.9922C27.4618 18.8532 27.3726 18.5375 27.5116 18.287C27.6505 18.0365 27.9663 17.9472 28.2168 18.0862C28.4673 18.2252 28.5565 18.5409 28.4175 18.7914Z",
    fill: "url(#paint109_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9131 17.7402C27.7742 17.9907 27.4584 18.0799 27.2079 17.9409C26.9574 17.802 26.8682 17.4862 27.0072 17.2357C27.1461 16.9852 27.4619 16.896 27.7124 17.035C27.9629 17.1739 28.0521 17.4897 27.9131 17.7402Z",
    fill: "url(#paint110_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8375 28.3007C27.8375 28.3007 28.3437 29.1054 30.3461 29.416C32.3486 29.7266 39.4197 29.3285 39.4197 29.3285L39.4505 29.4863C39.4505 29.4863 29.9669 30.0389 26.343 30.0663C26.6673 28.9819 27.8375 28.3024 27.8375 28.3024V28.3007Z",
    fill: "url(#paint111_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8789 28.1291C27.9149 28.4122 27.7124 28.6713 27.4293 28.7074C27.1462 28.7434 26.8871 28.5409 26.8511 28.2578C26.815 27.9747 27.0175 27.7156 27.3006 27.6796C27.5838 27.6435 27.8429 27.846 27.8789 28.1291Z",
    fill: "url(#paint112_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2041 29.8123C26.2401 30.0954 26.0376 30.3545 25.7545 30.3905C25.4714 30.4265 25.2123 30.2241 25.1763 29.941C25.1402 29.6578 25.3427 29.3987 25.6258 29.3627C25.9089 29.3267 26.168 29.5291 26.2041 29.8123Z",
    fill: "url(#paint113_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.997 25.5894C23.0331 25.8725 22.8306 26.1316 22.5475 26.1677C22.2644 26.2037 22.0053 26.0012 21.9692 25.7181C21.9332 25.435 22.1357 25.1759 22.4188 25.1399C22.7019 25.1038 22.961 25.3063 22.997 25.5894Z",
    fill: "url(#paint114_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2131 26.051C22.2491 26.3358 22.0467 26.5932 21.7636 26.6292C21.4804 26.6653 21.2213 26.4628 21.1853 26.1797C21.1493 25.8966 21.3517 25.6375 21.6349 25.6014C21.918 25.5654 22.1771 25.7679 22.2131 26.051Z",
    fill: "url(#paint115_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6003 26.7307C21.6364 27.0138 21.4339 27.2729 21.1508 27.3089C20.8676 27.3449 20.6085 27.1425 20.5725 26.8594C20.5365 26.5762 20.739 26.3171 21.0221 26.2811C21.3052 26.2451 21.5643 26.4475 21.6003 26.7307Z",
    fill: "url(#paint116_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3193 26.993C22.3553 27.2761 22.1529 27.5352 21.8698 27.5712C21.5866 27.6072 21.3275 27.4048 21.2915 27.1217C21.2555 26.8385 21.4579 26.5794 21.7411 26.5434C22.0242 26.5074 22.2833 26.7098 22.3193 26.993Z",
    fill: "url(#paint117_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0263 26.4165C23.0624 26.6996 22.8599 26.9587 22.5768 26.9947C22.2937 27.0308 22.0346 26.8283 21.9985 26.5452C21.9625 26.2604 22.165 26.003 22.4481 25.9669C22.7312 25.9309 22.9903 26.1334 23.0263 26.4165Z",
    fill: "url(#paint118_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8498 26.7225C23.8859 27.0056 23.6834 27.2647 23.4003 27.3008C23.1172 27.3368 22.8581 27.1343 22.822 26.8512C22.786 26.5681 22.9885 26.309 23.2716 26.273C23.5547 26.2369 23.8138 26.4394 23.8498 26.7225Z",
    fill: "url(#paint119_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0949 27.2919C23.131 27.575 22.9285 27.8341 22.6454 27.8701C22.3623 27.9062 22.1032 27.7037 22.0671 27.4206C22.0311 27.1374 22.2336 26.8783 22.5167 26.8423C22.7998 26.8063 23.0589 27.0088 23.0949 27.2919Z",
    fill: "url(#paint120_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0093 28.1855C23.0453 28.4687 22.8428 28.7278 22.5597 28.7638C22.2766 28.7998 22.0175 28.5974 21.9814 28.3142C21.9454 28.0311 22.1479 27.772 22.431 27.736C22.7141 27.7 22.9732 27.9024 23.0093 28.1855Z",
    fill: "url(#paint121_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1618 29.0706C23.1979 29.3537 22.9954 29.6128 22.7123 29.6488C22.4292 29.6849 22.1701 29.4824 22.134 29.1993C22.098 28.9161 22.3005 28.6571 22.5836 28.621C22.8667 28.585 23.1258 28.7875 23.1618 29.0706Z",
    fill: "url(#paint122_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9443 28.52C23.9803 28.8032 23.7779 29.0623 23.4948 29.0983C23.2116 29.1343 22.9525 28.9318 22.9165 28.6487C22.8805 28.3656 23.0829 28.1065 23.3661 28.0705C23.6492 28.0345 23.9083 28.2369 23.9443 28.52Z",
    fill: "url(#paint123_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6306 26.1435C24.6666 26.4266 24.4642 26.6857 24.181 26.7218C23.8979 26.7578 23.6388 26.5553 23.6028 26.2722C23.5668 25.9891 23.7692 25.73 24.0523 25.694C24.3355 25.6579 24.5946 25.8604 24.6306 26.1435Z",
    fill: "url(#paint124_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5281 26.509C25.5641 26.7939 25.3616 27.0512 25.0785 27.0873C24.7954 27.1233 24.5363 26.9208 24.5002 26.6377C24.4642 26.3529 24.6667 26.0955 24.9498 26.0595C25.2329 26.0234 25.492 26.2259 25.5281 26.509Z",
    fill: "url(#paint125_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4748 27.5333C25.5109 27.8182 25.3084 28.0756 25.0253 28.1116C24.7422 28.1476 24.4831 27.9451 24.447 27.662C24.411 27.3772 24.6135 27.1198 24.8966 27.0838C25.1797 27.0477 25.4388 27.2502 25.4748 27.5333Z",
    fill: "url(#paint126_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1726 29.2165C24.2086 29.4996 24.0061 29.7587 23.723 29.7947C23.4399 29.8308 23.1808 29.6283 23.1448 29.3452C23.1087 29.062 23.3112 28.803 23.5943 28.7669C23.8775 28.7309 24.1366 28.9334 24.1726 29.2165Z",
    fill: "url(#paint127_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9704 29.1722C25.0065 29.4571 24.804 29.7145 24.5209 29.7505C24.236 29.7865 23.9787 29.5841 23.9426 29.3009C23.9066 29.0178 24.1091 28.7587 24.3922 28.7227C24.677 28.6867 24.9344 28.8891 24.9704 29.1722Z",
    fill: "url(#paint128_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6311 28.4107C25.6671 28.6939 25.4646 28.953 25.1815 28.989C24.8984 29.025 24.6393 28.8226 24.6033 28.5394C24.5672 28.2563 24.7697 27.9972 25.0528 27.9612C25.336 27.9252 25.595 28.1276 25.6311 28.4107Z",
    fill: "url(#paint129_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2007 27.2329C26.2367 27.5177 26.0342 27.7751 25.7511 27.8112C25.4663 27.8472 25.2089 27.6447 25.1729 27.3616C25.1368 27.0785 25.3393 26.8194 25.6224 26.7833C25.9072 26.7473 26.1646 26.9498 26.2007 27.2329Z",
    fill: "url(#paint130_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3808 28.0518C26.4169 28.3367 26.2144 28.5941 25.9313 28.6301C25.6482 28.6661 25.3891 28.4637 25.353 28.1805C25.317 27.8957 25.5195 27.6383 25.8026 27.6023C26.0857 27.5663 26.3448 27.7687 26.3808 28.0518Z",
    fill: "url(#paint131_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3672 29.004C26.4032 29.2888 26.2007 29.5462 25.9176 29.5822C25.6345 29.6183 25.3754 29.4158 25.3394 29.1327C25.3033 28.8478 25.5058 28.5905 25.7889 28.5544C26.072 28.5184 26.3311 28.7209 26.3672 29.004Z",
    fill: "url(#paint132_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1855 28.6298C27.2216 28.913 27.0191 29.1721 26.736 29.2081C26.4528 29.2441 26.1938 29.0417 26.1577 28.7585C26.1217 28.4754 26.3242 28.2163 26.6073 28.1803C26.8904 28.1443 27.1495 28.3467 27.1855 28.6298Z",
    fill: "url(#paint133_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0654 27.6625C27.1014 27.9456 26.899 28.2047 26.6158 28.2407C26.3327 28.2767 26.0736 28.0743 26.0376 27.7911C26.0016 27.5063 26.204 27.2489 26.4872 27.2129C26.7703 27.1769 27.0294 27.3793 27.0654 27.6625Z",
    fill: "url(#paint134_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7854 29.4056C25.8214 29.6904 25.6189 29.9478 25.3358 29.9838C25.0527 30.0199 24.7936 29.8174 24.7576 29.5343C24.7215 29.2494 24.924 28.9921 25.2071 28.956C25.4902 28.92 25.7493 29.1225 25.7854 29.4056Z",
    fill: "url(#paint135_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0364 29.4986C27.0724 29.7834 26.8699 30.0408 26.5868 30.0769C26.3037 30.1129 26.0446 29.9104 26.0085 29.6273C25.9725 29.3442 26.175 29.0851 26.4581 29.0491C26.7412 29.013 27.0003 29.2155 27.0364 29.4986Z",
    fill: "url(#paint136_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.872 29.129C27.9081 29.4122 27.7056 29.6713 27.4225 29.7073C27.1394 29.7433 26.8803 29.5409 26.8442 29.2577C26.8082 28.9746 27.0107 28.7155 27.2938 28.6795C27.5769 28.6435 27.836 28.8459 27.872 29.129Z",
    fill: "url(#paint137_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.406 30.0212C24.442 30.306 24.2395 30.5634 23.9564 30.5994C23.6733 30.6355 23.4142 30.433 23.3782 30.1499C23.3421 29.8668 23.5446 29.6077 23.8277 29.5716C24.1109 29.5356 24.3699 29.7381 24.406 30.0212Z",
    fill: "url(#paint138_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2605 30.0009C25.2965 30.2857 25.094 30.5431 24.8109 30.5791C24.5261 30.6151 24.2687 30.4127 24.2327 30.1295C24.1966 29.8447 24.3991 29.5873 24.6822 29.5513C24.9671 29.5153 25.2244 29.7177 25.2605 30.0009Z",
    fill: "url(#paint139_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5151 29.6186C22.5511 29.9017 22.3487 30.1608 22.0656 30.1968C21.7824 30.2329 21.5233 30.0304 21.4873 29.7473C21.4513 29.4642 21.6537 29.2051 21.9369 29.169C22.22 29.133 22.4791 29.3355 22.5151 29.6186Z",
    fill: "url(#paint140_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4656 29.8031C23.5016 30.0862 23.2991 30.3453 23.016 30.3814C22.7329 30.4174 22.4738 30.2149 22.4377 29.9318C22.4017 29.6487 22.6042 29.3896 22.8873 29.3535C23.1704 29.3175 23.4295 29.52 23.4656 29.8031Z",
    fill: "url(#paint141_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.459 27.5227C24.495 27.8058 24.2925 28.0649 24.0094 28.1009C23.7246 28.1369 23.4672 27.9345 23.4312 27.6513C23.3951 27.3682 23.5976 27.1091 23.8807 27.0731C24.1638 27.0371 24.4229 27.2395 24.459 27.5227Z",
    fill: "url(#paint142_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5198 27.5715C21.5558 27.8546 21.3533 28.1137 21.0702 28.1497C20.7871 28.1857 20.528 27.9833 20.4919 27.7002C20.4559 27.417 20.6584 27.1579 20.9415 27.1219C21.2246 27.0859 21.4837 27.2883 21.5198 27.5715Z",
    fill: "url(#paint143_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2524 27.9146C22.2885 28.1977 22.086 28.4568 21.8029 28.4928C21.5197 28.5289 21.2606 28.3264 21.2246 28.0433C21.1886 27.7602 21.3911 27.5011 21.6742 27.465C21.9573 27.429 22.2164 27.6315 22.2524 27.9146Z",
    fill: "url(#paint144_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2749 28.7961C22.3109 29.0792 22.1084 29.3383 21.8253 29.3743C21.5422 29.4104 21.2831 29.2079 21.2471 28.9248C21.211 28.6416 21.4135 28.3825 21.6966 28.3465C21.9798 28.3105 22.2388 28.513 22.2749 28.7961Z",
    fill: "url(#paint145_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4546 28.4636C21.4906 28.7484 21.2881 29.0058 21.005 29.0419C20.7202 29.0779 20.4628 28.8754 20.4268 28.5923C20.3907 28.3092 20.5932 28.0501 20.8763 28.0141C21.1612 27.978 21.4185 28.1805 21.4546 28.4636Z",
    fill: "url(#paint146_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8003 25.7902C23.8363 26.0733 23.6338 26.3324 23.3507 26.3685C23.0676 26.4045 22.8085 26.202 22.7725 25.9189C22.7364 25.6341 22.9389 25.3767 23.222 25.3407C23.5051 25.3046 23.7642 25.5071 23.8003 25.7902Z",
    fill: "url(#paint147_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7575 26.8989C24.7936 27.1838 24.5911 27.4411 24.308 27.4772C24.0249 27.5132 23.7658 27.3107 23.7297 27.0276C23.6937 26.7428 23.8962 26.4854 24.1793 26.4494C24.4624 26.4133 24.7215 26.6158 24.7575 26.8989Z",
    fill: "url(#paint148_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8108 28.2715C24.8468 28.5546 24.6443 28.8137 24.3612 28.8497C24.0781 28.8857 23.819 28.6833 23.783 28.4001C23.7469 28.117 23.9494 27.8579 24.2325 27.8219C24.5156 27.7859 24.7747 27.9883 24.8108 28.2715Z",
    fill: "url(#paint149_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7829 27.7204C23.819 28.0052 23.6165 28.2626 23.3334 28.2987C23.0503 28.3347 22.7912 28.1322 22.7551 27.8491C22.7191 27.5643 22.9216 27.3069 23.2047 27.2709C23.4878 27.2348 23.7469 27.4373 23.7829 27.7204Z",
    fill: "url(#paint150_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6589 39.2321C31.8666 39.4294 31.8751 39.7571 31.6795 39.9647C31.4822 40.1724 31.1545 40.1809 30.9469 39.9853C30.7392 39.788 30.7307 39.4603 30.9263 39.2526C31.1236 39.045 31.4513 39.0364 31.6589 39.2321Z",
    fill: "url(#paint151_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6433 39.5752C30.8509 39.7725 30.8595 40.1002 30.6639 40.3079C30.4666 40.5155 30.1389 40.5241 29.9312 40.3285C29.7236 40.1311 29.715 39.8034 29.9106 39.5958C30.108 39.3882 30.4357 39.3796 30.6433 39.5752Z",
    fill: "url(#paint152_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5286 34.2062C36.9387 33.791 37.2596 33.2968 37.5787 32.8078C38.1347 31.9533 38.6923 31.2206 39.1882 30.2065L39.4988 29.5167L39.6052 29.8376C39.6052 29.8376 37.0382 35.3884 34.2276 37.5436C34.032 36.5295 33.5344 36.0851 33.5344 36.0851L35.2606 35.0882L36.5286 34.2062Z",
    fill: "url(#paint153_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.032 35.2924C34.2396 35.4897 34.2482 35.8174 34.0526 36.025C33.8553 36.2327 33.5275 36.2412 33.3199 36.0456C33.1123 35.8483 33.1037 35.5206 33.2993 35.313C33.4966 35.1053 33.8244 35.0967 34.032 35.2924Z",
    fill: "url(#paint154_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8057 37.6567C34.0133 37.854 34.0219 38.1817 33.8263 38.3894C33.6307 38.597 33.3012 38.6056 33.0936 38.41C32.886 38.2126 32.8774 37.8849 33.073 37.6773C33.2686 37.4697 33.5981 37.4611 33.8057 37.6567Z",
    fill: "url(#paint155_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.646 36.4321C28.8536 36.6294 28.8622 36.9571 28.6666 37.1648C28.4693 37.3724 28.1415 37.381 27.9339 37.1853C27.7263 36.988 27.7177 36.6603 27.9133 36.4527C28.1107 36.245 28.4384 36.2365 28.646 36.4321Z",
    fill: "url(#paint156_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 37.2861C28.5414 37.4834 28.5499 37.8112 28.3543 38.0188C28.157 38.2264 27.8293 38.235 27.6217 38.0394C27.414 37.8438 27.4055 37.5143 27.6011 37.3067C27.7984 37.0991 28.1261 37.0905 28.3337 37.2861Z",
    fill: "url(#paint157_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2942 38.1986C28.5018 38.3959 28.5104 38.7236 28.3148 38.9313C28.1192 39.1389 27.7897 39.1475 27.5821 38.9519C27.3745 38.7545 27.3659 38.4268 27.5615 38.2192C27.7571 38.0116 28.0866 38.003 28.2942 38.1986Z",
    fill: "url(#paint158_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0166 37.9464C29.2242 38.1438 29.2328 38.4715 29.0372 38.6791C28.8399 38.8867 28.5121 38.8953 28.3045 38.6997C28.0969 38.5024 28.0883 38.1747 28.2839 37.967C28.4813 37.7594 28.809 37.7508 29.0166 37.9464Z",
    fill: "url(#paint159_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1968 37.0507C29.4044 37.2481 29.413 37.5758 29.2174 37.7834C29.0201 37.991 28.6923 37.9996 28.4847 37.804C28.2771 37.6067 28.2685 37.2789 28.4641 37.0713C28.6614 36.8637 28.9892 36.8551 29.1968 37.0507Z",
    fill: "url(#paint160_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0254 36.7645C30.233 36.9619 30.2416 37.2896 30.046 37.4972C29.8487 37.7048 29.5209 37.7134 29.3133 37.5178C29.1057 37.3205 29.0971 36.9927 29.2927 36.7851C29.49 36.5775 29.8178 36.5689 30.0254 36.7645Z",
    fill: "url(#paint161_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8042 37.6841C30.0118 37.8815 30.0204 38.2092 29.8248 38.4168C29.6275 38.6244 29.2997 38.633 29.0921 38.4374C28.8845 38.2401 28.8759 37.9123 29.0715 37.7047C29.2689 37.4971 29.5966 37.4885 29.8042 37.6841Z",
    fill: "url(#paint162_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3052 38.4284C30.5128 38.6257 30.5214 38.9534 30.3258 39.161C30.1285 39.3687 29.8007 39.3772 29.5931 39.1816C29.3855 38.9843 29.3769 38.6566 29.5725 38.449C29.7698 38.2413 30.0976 38.2328 30.3052 38.4284Z",
    fill: "url(#paint163_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9863 39.016C31.194 39.2133 31.2025 39.5411 31.0069 39.7487C30.8096 39.9563 30.4819 39.9649 30.2743 39.7693C30.0666 39.5737 30.0581 39.2442 30.2537 39.0366C30.451 38.829 30.7787 38.8204 30.9863 39.016Z",
    fill: "url(#paint164_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2713 38.0827C31.4789 38.28 31.4875 38.6077 31.2918 38.8154C31.0945 39.023 30.7668 39.0316 30.5592 38.8359C30.3515 38.6386 30.343 38.3109 30.5386 38.1033C30.7359 37.8956 31.0636 37.8871 31.2713 38.0827Z",
    fill: "url(#paint165_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2605 35.8231C30.4681 36.0204 30.4767 36.3481 30.2811 36.5558C30.0838 36.7634 29.756 36.7719 29.5484 36.5763C29.3408 36.379 29.3322 36.0513 29.5278 35.8437C29.7234 35.636 30.0529 35.6275 30.2605 35.8231Z",
    fill: "url(#paint166_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1856 35.5343C31.3932 35.7317 31.4018 36.0594 31.2061 36.267C31.0088 36.4746 30.6811 36.4832 30.4735 36.2876C30.2659 36.092 30.2573 35.7625 30.4529 35.5549C30.6502 35.3473 30.9779 35.3387 31.1856 35.5343Z",
    fill: "url(#paint167_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7964 36.3614C32.004 36.5587 32.0126 36.8865 31.817 37.0941C31.6197 37.3017 31.2919 37.3103 31.0843 37.1147C30.8767 36.9174 30.8681 36.5896 31.0637 36.382C31.261 36.1744 31.5888 36.1658 31.7964 36.3614Z",
    fill: "url(#paint168_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8599 38.4873C32.0675 38.6847 32.0761 39.0124 31.8805 39.22C31.6831 39.4276 31.3554 39.4362 31.1478 39.2406C30.9402 39.0433 30.9316 38.7155 31.1272 38.5079C31.3245 38.3003 31.6523 38.2917 31.8599 38.4873Z",
    fill: "url(#paint169_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.395 37.9693C32.6026 38.1666 32.6112 38.4944 32.4156 38.702C32.22 38.9096 31.8906 38.9182 31.6829 38.7226C31.4753 38.5253 31.4667 38.1975 31.6624 37.9899C31.858 37.7823 32.1874 37.7737 32.395 37.9693Z",
    fill: "url(#paint170_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4741 36.9379C32.6818 37.1352 32.6903 37.4629 32.4947 37.6706C32.2974 37.8782 31.9697 37.8868 31.762 37.6911C31.5544 37.4938 31.5458 37.1661 31.7415 36.9585C31.9388 36.7509 32.2665 36.7423 32.4741 36.9379Z",
    fill: "url(#paint171_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1653 35.666C32.3729 35.8633 32.3815 36.1911 32.1859 36.3987C31.9903 36.6063 31.6608 36.6149 31.4532 36.4193C31.2456 36.2219 31.237 35.8942 31.4326 35.6866C31.6299 35.479 31.9577 35.4704 32.1653 35.666Z",
    fill: "url(#paint172_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8259 36.1845C33.0336 36.3818 33.0421 36.7096 32.8465 36.9172C32.6492 37.1248 32.3215 37.1334 32.1139 36.9378C31.9062 36.7405 31.8977 36.4127 32.0933 36.2051C32.2906 35.9975 32.6183 35.9889 32.8259 36.1845Z",
    fill: "url(#paint173_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4194 36.9292C33.6271 37.1266 33.6356 37.4543 33.44 37.6619C33.2427 37.8695 32.915 37.8781 32.7074 37.6825C32.4997 37.4852 32.4912 37.1574 32.6868 36.9498C32.8841 36.7422 33.2118 36.7336 33.4194 36.9292Z",
    fill: "url(#paint174_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8142 36.1194C34.0218 36.3168 34.0304 36.6445 33.8348 36.8521C33.6375 37.0597 33.3098 37.0683 33.1021 36.8727C32.8945 36.6754 32.8859 36.3477 33.0815 36.14C33.2789 35.9324 33.6066 35.9238 33.8142 36.1194Z",
    fill: "url(#paint175_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1055 35.45C33.3131 35.6473 33.3217 35.975 33.1261 36.1826C32.9305 36.3902 32.601 36.3988 32.3934 36.2032C32.1858 36.0059 32.1772 35.6782 32.3728 35.4705C32.5684 35.2629 32.8979 35.2543 33.1055 35.45Z",
    fill: "url(#paint176_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2256 37.6069C33.4332 37.8042 33.4418 38.1319 33.2462 38.3395C33.0489 38.5472 32.7211 38.5557 32.5135 38.3601C32.3059 38.1628 32.2973 37.8351 32.4929 37.6275C32.6902 37.4198 33.018 37.4113 33.2256 37.6069Z",
    fill: "url(#paint177_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 36.8845C34.4576 37.0818 34.4662 37.4096 34.2706 37.6172C34.0733 37.8248 33.7455 37.8334 33.5379 37.6378C33.3303 37.4404 33.3217 37.1127 33.5173 36.9051C33.7147 36.6975 34.0424 36.6889 34.25 36.8845Z",
    fill: "url(#paint178_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8609 34.8842C35.0685 35.0815 35.077 35.4092 34.8814 35.6168C34.6841 35.8245 34.3564 35.833 34.1488 35.6374C33.9411 35.4401 33.9326 35.1124 34.1282 34.9047C34.3255 34.6971 34.6532 34.6885 34.8609 34.8842Z",
    fill: "url(#paint179_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3499 35.4845C35.5575 35.6818 35.5661 36.0096 35.3705 36.2172C35.1731 36.4248 34.8454 36.4334 34.6378 36.2378C34.4302 36.0405 34.4216 35.7127 34.6172 35.5051C34.8145 35.2975 35.1422 35.2889 35.3499 35.4845Z",
    fill: "url(#paint180_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.084 36.5947C35.2916 36.7921 35.3002 37.1198 35.1046 37.3274C34.9073 37.535 34.5795 37.5436 34.3719 37.348C34.1643 37.1507 34.1557 36.823 34.3513 36.6153C34.5486 36.4077 34.8764 36.3991 35.084 36.5947Z",
    fill: "url(#paint181_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2112 35.1566C36.4188 35.354 36.4274 35.6817 36.2318 35.8893C36.0345 36.0969 35.7067 36.1055 35.4991 35.9099C35.2915 35.7126 35.2829 35.3848 35.4785 35.1772C35.6758 34.9696 36.0036 34.961 36.2112 35.1566Z",
    fill: "url(#paint182_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7703 35.941C35.9779 36.1383 35.9865 36.4661 35.7909 36.6737C35.5935 36.8813 35.2658 36.8899 35.0582 36.6943C34.8506 36.497 34.842 36.1692 35.0376 35.9616C35.2349 35.754 35.5627 35.7454 35.7703 35.941Z",
    fill: "url(#paint183_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7527 37.435C34.9603 37.6324 34.9689 37.9601 34.7733 38.1677C34.576 38.3753 34.2482 38.3839 34.0406 38.1883C33.833 37.991 33.8244 37.6633 34.02 37.4556C34.2173 37.248 34.5451 37.2394 34.7527 37.435Z",
    fill: "url(#paint184_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7481 34.5873C35.9557 34.7846 35.9643 35.1123 35.7686 35.32C35.5713 35.5276 35.2436 35.5362 35.036 35.3405C34.8284 35.1432 34.8198 34.8155 35.0154 34.6079C35.2127 34.4003 35.5404 34.3917 35.7481 34.5873Z",
    fill: "url(#paint185_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.491 34.2009C36.6986 34.3983 36.7072 34.726 36.5116 34.9336C36.3142 35.1412 35.9865 35.1498 35.7789 34.9542C35.5713 34.7569 35.5627 34.4292 35.7583 34.2215C35.9556 34.0139 36.2834 34.0053 36.491 34.2009Z",
    fill: "url(#paint186_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5513 38.9606C32.7589 39.1579 32.7675 39.4857 32.5719 39.6933C32.3745 39.9009 32.0468 39.9095 31.8392 39.7139C31.6316 39.5165 31.623 39.1888 31.8186 38.9812C32.0159 38.7736 32.3437 38.765 32.5513 38.9606Z",
    fill: "url(#paint187_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1983 38.4014C33.4059 38.5987 33.4145 38.9265 33.2188 39.1341C33.0215 39.3417 32.6938 39.3503 32.4862 39.1547C32.2785 38.9574 32.27 38.6296 32.4656 38.422C32.6612 38.2144 32.9906 38.2058 33.1983 38.4014Z",
    fill: "url(#paint188_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3765 39.3353C28.5841 39.5326 28.5927 39.8603 28.3971 40.0679C28.1997 40.2755 27.872 40.2841 27.6644 40.0885C27.4568 39.8912 27.4482 39.5635 27.6438 39.3558C27.8411 39.1482 28.1689 39.1396 28.3765 39.3353Z",
    fill: "url(#paint189_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0054 36.9958C31.213 37.1932 31.2216 37.5209 31.026 37.7285C30.8286 37.9361 30.5009 37.9447 30.2933 37.7491C30.0857 37.5518 30.0771 37.224 30.2727 37.0164C30.47 36.8088 30.7978 36.8002 31.0054 36.9958Z",
    fill: "url(#paint190_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7644 38.9026C28.972 39.1 28.9806 39.4277 28.785 39.6353C28.5877 39.8429 28.2599 39.8515 28.0523 39.6559C27.8447 39.4603 27.8361 39.1309 28.0317 38.9232C28.2291 38.7156 28.5568 38.707 28.7644 38.9026Z",
    fill: "url(#paint191_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5486 38.7003C29.7562 38.8977 29.7648 39.2254 29.5692 39.433C29.3719 39.6406 29.0441 39.6492 28.8365 39.4536C28.6289 39.2563 28.6203 38.9285 28.8159 38.7209C29.0132 38.5133 29.341 38.5047 29.5486 38.7003Z",
    fill: "url(#paint192_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1267 39.3673C30.3343 39.5646 30.3429 39.8923 30.1473 40.1C29.9517 40.3076 29.6223 40.3162 29.4146 40.1205C29.207 39.9232 29.1984 39.5955 29.394 39.3879C29.5914 39.1803 29.9191 39.1717 30.1267 39.3673Z",
    fill: "url(#paint193_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2808 39.6321C29.4884 39.8295 29.497 40.1572 29.3014 40.3648C29.104 40.5724 28.7763 40.581 28.5687 40.3854C28.3611 40.1881 28.3525 39.8603 28.5481 39.6527C28.7454 39.4451 29.0732 39.4365 29.2808 39.6321Z",
    fill: "url(#paint194_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3958 36.0767C29.6034 36.2741 29.612 36.6018 29.4164 36.8094C29.219 37.017 28.8913 37.0256 28.6837 36.83C28.4761 36.6327 28.4675 36.305 28.6631 36.0973C28.8604 35.8897 29.1881 35.8811 29.3958 36.0767Z",
    fill: "url(#paint195_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8389 36.3253C31.0465 36.5227 31.0551 36.8504 30.8595 37.058C30.6621 37.2656 30.3344 37.2742 30.1268 37.0786C29.9192 36.8813 29.9106 36.5535 30.1062 36.3459C30.3035 36.1383 30.6313 36.1297 30.8389 36.3253Z",
    fill: "url(#paint196_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7517 37.3532C31.9593 37.5505 31.9679 37.8783 31.7723 38.0859C31.575 38.2935 31.2473 38.3021 31.0396 38.1065C30.832 37.9091 30.8234 37.5814 31.019 37.3738C31.2164 37.1662 31.5441 37.1576 31.7517 37.3532Z",
    fill: "url(#paint197_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6072 37.5779C30.8148 37.7752 30.8234 38.103 30.6278 38.3106C30.4305 38.5182 30.1027 38.5268 29.8951 38.3312C29.6875 38.1338 29.6789 37.8061 29.8745 37.5985C30.0718 37.3909 30.3996 37.3823 30.6072 37.5779Z",
    fill: "url(#paint198_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.667 35.9273C34.8746 36.1246 34.8832 36.4523 34.6876 36.66C34.4903 36.8676 34.1625 36.8762 33.9549 36.6806C33.7473 36.4832 33.7387 36.1555 33.9343 35.9479C34.1317 35.7403 34.4594 35.7317 34.667 35.9273Z",
    fill: "url(#paint199_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6275 31.2852C34.6275 31.2852 37.1944 31.1067 39.5023 29.7838L39.5194 30.0171C39.5194 30.0171 35.8646 31.8823 33.1535 33.1983C32.3488 31.8497 34.6275 31.2852 34.6275 31.2852Z",
    fill: "url(#paint200_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2454 30.6957C31.3964 30.9394 31.3209 31.2585 31.0773 31.4095C30.8336 31.5605 30.5145 31.485 30.3635 31.2414C30.2125 30.9977 30.288 30.6785 30.5316 30.5275C30.7753 30.3766 31.0944 30.4521 31.2454 30.6957Z",
    fill: "url(#paint201_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6168 34.7162C28.7677 34.9599 28.6922 35.279 28.4486 35.43C28.2049 35.581 27.8858 35.5055 27.7348 35.2619C27.5838 35.0182 27.6593 34.6991 27.9029 34.5481C28.1466 34.3971 28.4658 34.4726 28.6168 34.7162Z",
    fill: "url(#paint202_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9317 31.3571C32.0827 31.6007 32.0072 31.9199 31.7635 32.0709C31.5199 32.2219 31.2007 32.1464 31.0497 31.9027C30.8987 31.6591 30.9742 31.3399 31.2179 31.1889C31.4615 31.0379 31.7807 31.1134 31.9317 31.3571Z",
    fill: "url(#paint203_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1082 33.5841C31.2592 33.8278 31.1837 34.1469 30.9401 34.2979C30.6964 34.4489 30.3772 34.3734 30.2262 34.1298C30.0753 33.8861 30.1508 33.567 30.3944 33.416C30.6381 33.265 30.9572 33.3405 31.1082 33.5841Z",
    fill: "url(#paint204_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4341 31.0785C26.5851 31.3221 26.5096 31.6413 26.266 31.7923C26.0223 31.9433 25.7032 31.8678 25.5522 31.6241C25.4012 31.3805 25.4767 31.0613 25.7203 30.9103C25.964 30.7593 26.2831 30.8348 26.4341 31.0785Z",
    fill: "url(#paint205_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9144 31.8253C26.0654 32.0689 25.9899 32.3881 25.7462 32.5391C25.5025 32.69 25.1834 32.6146 25.0324 32.3709C24.8814 32.1272 24.9569 31.8081 25.2006 31.6571C25.4442 31.5061 25.7634 31.5816 25.9144 31.8253Z",
    fill: "url(#paint206_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6397 32.6986C25.7907 32.9422 25.7152 33.2614 25.4715 33.4124C25.2279 33.5634 24.9087 33.4879 24.7577 33.2442C24.6067 33.0006 24.6822 32.6814 24.9259 32.5304C25.1696 32.3794 25.4887 32.4549 25.6397 32.6986Z",
    fill: "url(#paint207_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4031 32.6386C26.5541 32.8823 26.4786 33.2014 26.235 33.3524C25.9913 33.5034 25.6722 33.4279 25.5212 33.1843C25.3702 32.9406 25.4457 32.6215 25.6893 32.4705C25.933 32.3195 26.2521 32.395 26.4031 32.6386Z",
    fill: "url(#paint208_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8064 31.8186C26.9574 32.0623 26.8819 32.3814 26.6383 32.5324C26.3946 32.6834 26.0755 32.6079 25.9245 32.3643C25.7735 32.1206 25.849 31.8015 26.0926 31.6505C26.3363 31.4995 26.6555 31.575 26.8064 31.8186Z",
    fill: "url(#paint209_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6814 31.7531C27.8324 31.9967 27.7569 32.3159 27.5133 32.4669C27.2696 32.6179 26.9505 32.5424 26.7995 32.2987C26.6485 32.0551 26.724 31.7359 26.9676 31.5849C27.2113 31.4339 27.5305 31.5094 27.6814 31.7531Z",
    fill: "url(#paint210_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.232 32.5873C27.383 32.8309 27.3075 33.1501 27.0638 33.3011C26.8202 33.4521 26.501 33.3766 26.35 33.1329C26.199 32.8893 26.2745 32.5701 26.5182 32.4191C26.7618 32.2681 27.081 32.3436 27.232 32.5873Z",
    fill: "url(#paint211_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5272 33.4347C27.6781 33.6783 27.6026 33.9975 27.359 34.1485C27.1153 34.2995 26.7962 34.224 26.6452 33.9803C26.4942 33.7367 26.5697 33.4175 26.8133 33.2665C27.057 33.1155 27.3762 33.191 27.5272 33.4347Z",
    fill: "url(#paint212_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0333 34.1764C28.1843 34.42 28.1088 34.7392 27.8651 34.8902C27.6214 35.0412 27.3023 34.9657 27.1513 34.722C27.0003 34.4784 27.0758 34.1592 27.3195 34.0082C27.5631 33.8572 27.8823 33.9327 28.0333 34.1764Z",
    fill: "url(#paint213_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5499 33.3472C28.7009 33.5909 28.6254 33.9101 28.3817 34.061C28.138 34.212 27.8189 34.1365 27.6679 33.8929C27.5169 33.6492 27.5924 33.3301 27.8361 33.1791C28.0797 33.0281 28.3989 33.1036 28.5499 33.3472Z",
    fill: "url(#paint214_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 30.9036C28.3009 31.1473 28.2255 31.4664 27.9818 31.6174C27.7381 31.7684 27.419 31.6929 27.268 31.4493C27.117 31.2056 27.1925 30.8865 27.4362 30.7355C27.6798 30.5845 27.999 30.66 28.15 30.9036Z",
    fill: "url(#paint215_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1177 30.8624C29.2687 31.1061 29.1932 31.4252 28.9496 31.5762C28.7059 31.7272 28.3868 31.6517 28.2358 31.4081C28.0848 31.1644 28.1603 30.8453 28.4039 30.6943C28.6476 30.5433 28.9667 30.6188 29.1177 30.8624Z",
    fill: "url(#paint216_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4969 31.8166C29.6479 32.0603 29.5724 32.3794 29.3287 32.5304C29.0851 32.6814 28.7659 32.6059 28.6149 32.3623C28.4639 32.1186 28.5394 31.7995 28.7831 31.6485C29.0267 31.4975 29.3459 31.573 29.4969 31.8166Z",
    fill: "url(#paint217_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.013 33.8897C29.164 34.1333 29.0885 34.4525 28.8448 34.6035C28.6012 34.7544 28.282 34.679 28.131 34.4353C27.98 34.1916 28.0555 33.8725 28.2992 33.7215C28.5428 33.5705 28.862 33.646 29.013 33.8897Z",
    fill: "url(#paint218_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6651 33.5236C29.8161 33.7673 29.7406 34.0865 29.4969 34.2374C29.2533 34.3884 28.9341 34.3129 28.7831 34.0693C28.6321 33.8256 28.7076 33.5065 28.9513 33.3555C29.1949 33.2045 29.5141 33.28 29.6651 33.5236Z",
    fill: "url(#paint219_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0032 32.5491C30.1542 32.7928 30.0787 33.1119 29.8351 33.2629C29.5914 33.4139 29.2723 33.3384 29.1213 33.0948C28.9703 32.8511 29.0458 32.532 29.2894 32.381C29.5331 32.23 29.8522 32.3055 30.0032 32.5491Z",
    fill: "url(#paint220_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0323 31.2401C30.1833 31.4838 30.1078 31.803 29.8641 31.9539C29.6205 32.1049 29.3013 32.0294 29.1503 31.7858C28.9993 31.5421 29.0748 31.223 29.3185 31.072C29.5621 30.921 29.8813 30.9965 30.0323 31.2401Z",
    fill: "url(#paint221_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5367 31.9096C30.6877 32.1533 30.6122 32.4724 30.3685 32.6234C30.1249 32.7744 29.8057 32.6989 29.6547 32.4553C29.5037 32.2116 29.5792 31.8925 29.8229 31.7415C30.0665 31.5905 30.3857 31.666 30.5367 31.9096Z",
    fill: "url(#paint222_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9212 32.7815C31.0722 33.0251 30.9967 33.3443 30.753 33.4953C30.5094 33.6463 30.1902 33.5708 30.0392 33.3271C29.8882 33.0835 29.9637 32.7643 30.2074 32.6133C30.451 32.4623 30.7702 32.5378 30.9212 32.7815Z",
    fill: "url(#paint223_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5096 32.0998C31.6606 32.3434 31.5851 32.6626 31.3414 32.8136C31.0978 32.9646 30.7786 32.8891 30.6276 32.6454C30.4766 32.4018 30.5521 32.0826 30.7958 31.9316C31.0394 31.7806 31.3586 31.8561 31.5096 32.0998Z",
    fill: "url(#paint224_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9966 31.2712C31.1476 31.5148 31.0721 31.834 30.8285 31.985C30.5848 32.136 30.2657 32.0605 30.1147 31.8168C29.9637 31.5732 30.0392 31.254 30.2828 31.103C30.5265 30.952 30.8456 31.0275 30.9966 31.2712Z",
    fill: "url(#paint225_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1988 30.59C30.3498 30.8336 30.2743 31.1528 30.0306 31.3038C29.787 31.4548 29.4678 31.3793 29.3168 31.1356C29.1658 30.892 29.2413 30.5728 29.485 30.4218C29.7286 30.2708 30.0478 30.3463 30.1988 30.59Z",
    fill: "url(#paint226_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3521 30.6057C32.5031 30.8494 32.4276 31.1685 32.1839 31.3195C31.9403 31.4705 31.6211 31.395 31.4701 31.1514C31.3191 30.9077 31.3946 30.5886 31.6383 30.4376C31.882 30.2866 32.2011 30.3621 32.3521 30.6057Z",
    fill: "url(#paint227_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5591 33.3884C30.7101 33.6321 30.6346 33.9512 30.391 34.1022C30.1473 34.2532 29.8282 34.1777 29.6772 33.9341C29.5262 33.6904 29.6017 33.3713 29.8453 33.2203C30.089 33.0693 30.4081 33.1448 30.5591 33.3884Z",
    fill: "url(#paint228_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7344 32.9512C31.8854 33.1949 31.8099 33.514 31.5663 33.665C31.3226 33.816 31.0035 33.7405 30.8525 33.4969C30.7015 33.2532 30.777 32.9341 31.0206 32.7831C31.2643 32.6321 31.5834 32.7076 31.7344 32.9512Z",
    fill: "url(#paint229_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8377 31.1751C32.9887 31.4187 32.9132 31.7379 32.6695 31.8889C32.4259 32.0399 32.1067 31.9644 31.9557 31.7207C31.8047 31.4771 31.8802 31.1579 32.1239 31.0069C32.3675 30.8559 32.6867 30.9314 32.8377 31.1751Z",
    fill: "url(#paint230_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1551 31.8786C33.3061 32.1223 33.2306 32.4414 32.9869 32.5924C32.7433 32.7434 32.4241 32.6679 32.2731 32.4243C32.1221 32.1806 32.1976 31.8615 32.4413 31.7105C32.6849 31.5595 33.0041 31.635 33.1551 31.8786Z",
    fill: "url(#paint231_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6148 32.8841C32.7658 33.1278 32.6903 33.4469 32.4466 33.5979C32.203 33.7489 31.8838 33.6734 31.7328 33.4298C31.5818 33.1861 31.6573 32.867 31.901 32.716C32.1447 32.565 32.4638 32.6405 32.6148 32.8841Z",
    fill: "url(#paint232_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0389 31.9813C34.1899 32.225 34.1144 32.5441 33.8707 32.6951C33.6271 32.8461 33.3079 32.7706 33.1569 32.527C33.0059 32.2833 33.0814 31.9642 33.3251 31.8132C33.5687 31.6622 33.8879 31.7377 34.0389 31.9813Z",
    fill: "url(#paint233_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4451 32.7057C33.5961 32.9494 33.5206 33.2685 33.277 33.4195C33.0333 33.5705 32.7142 33.495 32.5632 33.2514C32.4122 33.0077 32.4877 32.6886 32.7313 32.5376C32.975 32.3866 33.2941 32.4621 33.4451 32.7057Z",
    fill: "url(#paint234_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0794 33.6131C32.2304 33.8568 32.1549 34.1759 31.9112 34.3269C31.6676 34.4779 31.3484 34.4024 31.1974 34.1588C31.0464 33.9151 31.1219 33.596 31.3656 33.445C31.6092 33.294 31.9284 33.3695 32.0794 33.6131Z",
    fill: "url(#paint235_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7713 31.1131C33.9223 31.3567 33.8468 31.6759 33.6031 31.8269C33.3595 31.9779 33.0403 31.9024 32.8893 31.6587C32.7383 31.4151 32.8138 31.0959 33.0575 30.9449C33.3011 30.7939 33.6203 30.8694 33.7713 31.1131Z",
    fill: "url(#paint236_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7081 31.2625C34.8591 31.5062 34.7836 31.8253 34.5399 31.9763C34.2962 32.1273 33.9771 32.0518 33.8261 31.8082C33.6751 31.5645 33.7506 31.2454 33.9943 31.0944C34.2379 30.9434 34.5571 31.0189 34.7081 31.2625Z",
    fill: "url(#paint237_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5604 34.5231C29.7114 34.7667 29.6359 35.0859 29.3922 35.2369C29.1485 35.3879 28.8294 35.3124 28.6784 35.0687C28.5274 34.8251 28.6029 34.5059 28.8466 34.3549C29.0902 34.2039 29.4094 34.2794 29.5604 34.5231Z",
    fill: "url(#paint238_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3292 34.1489C30.4801 34.3926 30.4047 34.7117 30.161 34.8627C29.9173 35.0137 29.5982 34.9382 29.4472 34.6946C29.2962 34.4509 29.3717 34.1318 29.6154 33.9808C29.859 33.8298 30.1782 33.9053 30.3292 34.1489Z",
    fill: "url(#paint239_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6746 34.9445C27.8256 35.1881 27.7501 35.5073 27.5065 35.6583C27.2628 35.8093 26.9437 35.7338 26.7927 35.4901C26.6417 35.2465 26.7172 34.9273 26.9608 34.7763C27.2045 34.6253 27.5236 34.7008 27.6746 34.9445Z",
    fill: "url(#paint240_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5704 32.2279C28.7214 32.4715 28.6459 32.7907 28.4022 32.9417C28.1586 33.0927 27.8394 33.0172 27.6884 32.7735C27.5374 32.5299 27.6129 32.2107 27.8566 32.0597C28.1002 31.9087 28.4194 31.9842 28.5704 32.2279Z",
    fill: "url(#paint241_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9161 33.4967C26.0671 33.7404 25.9916 34.0595 25.7479 34.2105C25.5043 34.3615 25.1851 34.286 25.0341 34.0423C24.8831 33.7987 24.9586 33.4795 25.2023 33.3285C25.4459 33.1775 25.7651 33.253 25.9161 33.4967Z",
    fill: "url(#paint242_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7259 33.5033C26.8769 33.747 26.8014 34.0661 26.5577 34.2171C26.3141 34.3681 25.9949 34.2926 25.8439 34.049C25.6929 33.8053 25.7684 33.4862 26.0121 33.3352C26.2557 33.1842 26.5749 33.2597 26.7259 33.5033Z",
    fill: "url(#paint243_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1136 34.2958C27.2646 34.5395 27.1891 34.8586 26.9454 35.0096C26.7018 35.1606 26.3826 35.0851 26.2316 34.8415C26.0806 34.5978 26.1561 34.2787 26.3998 34.1277C26.6434 33.9767 26.9626 34.0522 27.1136 34.2958Z",
    fill: "url(#paint244_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2283 34.3355C26.3793 34.5791 26.3038 34.8983 26.0602 35.0493C25.8165 35.2003 25.4974 35.1248 25.3464 34.8811C25.1954 34.6375 25.2709 34.3183 25.5145 34.1673C25.7582 34.0163 26.0773 34.0918 26.2283 34.3355Z",
    fill: "url(#paint245_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2491 30.9275C27.4001 31.1712 27.3246 31.4903 27.0809 31.6413C26.8373 31.7923 26.5181 31.7168 26.3671 31.4732C26.2161 31.2295 26.2916 30.9104 26.5353 30.7594C26.7789 30.6084 27.0981 30.6839 27.2491 30.9275Z",
    fill: "url(#paint246_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5806 31.537C28.7316 31.7807 28.6561 32.0998 28.4125 32.2508C28.1688 32.4018 27.8497 32.3263 27.6987 32.0827C27.5477 31.839 27.6232 31.5199 27.8668 31.3689C28.1105 31.2179 28.4296 31.2934 28.5806 31.537Z",
    fill: "url(#paint247_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 32.7642C29.351 33.0078 29.2755 33.327 29.0318 33.478C28.7882 33.629 28.469 33.5535 28.318 33.3098C28.167 33.0662 28.2425 32.747 28.4862 32.596C28.7299 32.445 29.049 32.5205 29.2 32.7642Z",
    fill: "url(#paint248_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0367 32.6905C28.1877 32.9341 28.1122 33.2533 27.8685 33.4043C27.6249 33.5553 27.3057 33.4798 27.1547 33.2361C27.0037 32.9925 27.0792 32.6733 27.3229 32.5223C27.5665 32.3713 27.8857 32.4468 28.0367 32.6905Z",
    fill: "url(#paint249_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3831 32.1323C32.5341 32.3759 32.4586 32.6951 32.215 32.8461C31.9713 32.9971 31.6521 32.9216 31.5012 32.6779C31.3502 32.4343 31.4257 32.1151 31.6693 31.9641C31.913 31.8131 32.2321 31.8886 32.3831 32.1323Z",
    fill: "url(#paint250_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4041 30.6038C42.9356 31.0551 42.426 31.1529 41.9147 31.5544C41.7843 31.6573 41.5458 31.9199 41.4342 32.0383C41.043 32.4466 40.7479 32.946 40.5197 33.4727L40.4476 33.5088C40.4476 33.5088 38.7867 32.3883 38.8896 29.5829C39.0011 26.5544 40.2194 25.9504 40.9058 25.6226C41.1803 26.2198 41.4583 26.7362 41.7208 27.1189C42.0245 27.5599 42.402 27.9648 42.9047 28.344C43.1638 28.5379 43.495 28.7112 43.7009 28.96C44.1144 29.4627 43.8708 30.1525 43.4041 30.6038Z",
    fill: "url(#paint251_linear_2969_39905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4041 30.6031C42.9357 31.0544 42.3969 31.1556 41.8341 31.6395C41.7071 31.7476 41.5458 31.9192 41.4326 32.0376C40.4768 29.2116 41.5904 27.3224 41.7191 27.1182C42.0228 27.5592 42.4003 27.9641 42.9031 28.3433C43.1622 28.5372 43.5036 28.7105 43.7095 28.9593C44.1231 29.4621 43.8691 30.1519 43.4024 30.6031H43.4041Z",
    fill: "url(#paint252_linear_2969_39905)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2969_39905",
    x1: 9.57227,
    y1: 27.5252,
    x2: 41.8152,
    y2: 27.5252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2969_39905",
    x1: 27.4756,
    y1: 13.1224,
    x2: 32.9011,
    y2: 38.5087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2969_39905",
    x1: 31.2436,
    y1: 0.709621,
    x2: 32.8909,
    y2: 45.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2969_39905",
    x1: 35.3826,
    y1: 25.641,
    x2: 39.7169,
    y2: 25.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2969_39905",
    x1: 35.5061,
    y1: 23.2033,
    x2: 35.6073,
    y2: 24.8111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2969_39905",
    x1: 35.8784,
    y1: 21.2792,
    x2: 35.9779,
    y2: 22.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2969_39905",
    x1: 33.3767,
    y1: 21.7838,
    x2: 33.4779,
    y2: 23.3933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2969_39905",
    x1: 33.2497,
    y1: 18.16,
    x2: 33.3509,
    y2: 19.7677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2969_39905",
    x1: 32.4467,
    y1: 18.6007,
    x2: 32.5463,
    y2: 20.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2969_39905",
    x1: 34.0476,
    y1: 18.5924,
    x2: 34.1471,
    y2: 20.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2969_39905",
    x1: 33.1811,
    y1: 19.0115,
    x2: 33.2806,
    y2: 20.6192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2969_39905",
    x1: 32.2939,
    y1: 19.4078,
    x2: 32.3951,
    y2: 21.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2969_39905",
    x1: 34.552,
    y1: 19.3198,
    x2: 34.6532,
    y2: 20.9293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2969_39905",
    x1: 33.8725,
    y1: 19.5054,
    x2: 33.972,
    y2: 21.1149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2969_39905",
    x1: 32.3659,
    y1: 20.3614,
    x2: 32.4672,
    y2: 21.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2969_39905",
    x1: 32.8876,
    y1: 21.0687,
    x2: 32.9872,
    y2: 22.6765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2969_39905",
    x1: 34.5673,
    y1: 21.7579,
    x2: 34.6686,
    y2: 23.3674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2969_39905",
    x1: 33.9704,
    y1: 22.3364,
    x2: 34.0699,
    y2: 23.9441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2969_39905",
    x1: 35.1355,
    y1: 20.9706,
    x2: 35.235,
    y2: 22.5784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2969_39905",
    x1: 35.5061,
    y1: 20.5572,
    x2: 35.6073,
    y2: 22.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2969_39905",
    x1: 35.3669,
    y1: 21.8799,
    x2: 35.4681,
    y2: 23.4894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2969_39905",
    x1: 34.7871,
    y1: 22.6543,
    x2: 34.8883,
    y2: 24.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2969_39905",
    x1: 35.6604,
    y1: 22.6695,
    x2: 35.7616,
    y2: 24.2773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2969_39905",
    x1: 36.2868,
    y1: 22.1117,
    x2: 36.3881,
    y2: 23.7212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2969_39905",
    x1: 36.4189,
    y1: 23.0857,
    x2: 36.5201,
    y2: 24.6952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2969_39905",
    x1: 33.0576,
    y1: 19.8879,
    x2: 33.1571,
    y2: 21.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2969_39905",
    x1: 33.3664,
    y1: 20.6034,
    x2: 33.4676,
    y2: 22.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2969_39905",
    x1: 33.7473,
    y1: 21.4752,
    x2: 33.8485,
    y2: 23.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2969_39905",
    x1: 34.8093,
    y1: 20.0526,
    x2: 34.9105,
    y2: 21.6603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2969_39905",
    x1: 34.3049,
    y1: 20.8611,
    x2: 34.4061,
    y2: 22.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2969_39905",
    x1: 34.0166,
    y1: 20.1913,
    x2: 34.1161,
    y2: 21.7991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2969_39905",
    x1: 35.7909,
    y1: 26.2002,
    x2: 36.0243,
    y2: 29.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2969_39905",
    x1: 33.8537,
    y1: 25.8346,
    x2: 33.9549,
    y2: 27.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2969_39905",
    x1: 31.9816,
    y1: 27.2966,
    x2: 32.0829,
    y2: 28.9044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2969_39905",
    x1: 29.3237,
    y1: 22.7071,
    x2: 29.4249,
    y2: 24.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2969_39905",
    x1: 28.488,
    y1: 23.0687,
    x2: 28.5892,
    y2: 24.6764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2969_39905",
    x1: 27.7983,
    y1: 23.6663,
    x2: 27.8978,
    y2: 25.2758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2969_39905",
    x1: 28.4777,
    y1: 24.0183,
    x2: 28.579,
    y2: 25.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2969_39905",
    x1: 29.2517,
    y1: 23.5321,
    x2: 29.3529,
    y2: 25.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2969_39905",
    x1: 30.0307,
    y1: 23.9373,
    x2: 30.1302,
    y2: 25.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2969_39905",
    x1: 29.2104,
    y1: 24.409,
    x2: 29.3116,
    y2: 26.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2969_39905",
    x1: 29.0148,
    y1: 25.2861,
    x2: 29.1144,
    y2: 26.8939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2969_39905",
    x1: 29.0561,
    y1: 26.1833,
    x2: 29.1573,
    y2: 27.7911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2969_39905",
    x1: 29.9021,
    y1: 25.7338,
    x2: 30.0016,
    y2: 27.3432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2969_39905",
    x1: 30.8767,
    y1: 23.4604,
    x2: 30.9762,
    y2: 25.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2969_39905",
    x1: 31.7207,
    y1: 23.9337,
    x2: 31.8219,
    y2: 25.5432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2969_39905",
    x1: 31.5405,
    y1: 24.9443,
    x2: 31.6417,
    y2: 26.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2969_39905",
    x1: 30.041,
    y1: 26.4526,
    x2: 30.1405,
    y2: 28.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2969_39905",
    x1: 30.8371,
    y1: 26.5075,
    x2: 30.9383,
    y2: 28.1152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2969_39905",
    x1: 31.5869,
    y1: 25.8346,
    x2: 31.6881,
    y2: 27.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2969_39905",
    x1: 32.299,
    y1: 24.7366,
    x2: 32.4003,
    y2: 26.3443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2969_39905",
    x1: 32.3762,
    y1: 25.5723,
    x2: 32.4774,
    y2: 27.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2969_39905",
    x1: 32.2441,
    y1: 26.5151,
    x2: 32.3453,
    y2: 28.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2969_39905",
    x1: 33.1037,
    y1: 26.2448,
    x2: 33.2032,
    y2: 27.8526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2969_39905",
    x1: 33.1037,
    y1: 25.2708,
    x2: 33.2032,
    y2: 26.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2969_39905",
    x1: 31.6179,
    y1: 26.8406,
    x2: 31.7191,
    y2: 28.4484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2969_39905",
    x1: 32.8481,
    y1: 27.088,
    x2: 32.9493,
    y2: 28.6975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2969_39905",
    x1: 33.7214,
    y1: 26.8249,
    x2: 33.8226,
    y2: 28.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2969_39905",
    x1: 30.1713,
    y1: 27.2819,
    x2: 30.2726,
    y2: 28.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2969_39905",
    x1: 31.0224,
    y1: 27.3656,
    x2: 31.1237,
    y2: 28.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2969_39905",
    x1: 28.3474,
    y1: 26.6467,
    x2: 28.4469,
    y2: 28.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2969_39905",
    x1: 29.267,
    y1: 26.9489,
    x2: 29.3683,
    y2: 28.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2969_39905",
    x1: 30.5351,
    y1: 24.8082,
    x2: 30.6363,
    y2: 26.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2969_39905",
    x1: 27.613,
    y1: 24.4914,
    x2: 27.7125,
    y2: 26.1008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2969_39905",
    x1: 28.2976,
    y1: 24.9224,
    x2: 28.3988,
    y2: 26.5302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2969_39905",
    x1: 28.2102,
    y1: 25.8009,
    x2: 28.3114,
    y2: 27.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2969_39905",
    x1: 27.4362,
    y1: 25.3684,
    x2: 27.5375,
    y2: 26.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2969_39905",
    x1: 30.0976,
    y1: 23.0077,
    x2: 30.1988,
    y2: 24.6154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2969_39905",
    x1: 30.9091,
    y1: 24.2255,
    x2: 31.0104,
    y2: 25.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2969_39905",
    x1: 30.7548,
    y1: 25.5945,
    x2: 30.8561,
    y2: 27.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2969_39905",
    x1: 29.8403,
    y1: 24.9189,
    x2: 29.9398,
    y2: 26.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2969_39905",
    x1: 35.3289,
    y1: 22.1347,
    x2: 33.108,
    y2: 26.7973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2969_39905",
    x1: 30.8335,
    y1: 19.616,
    x2: 30.139,
    y2: 21.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2969_39905",
    x1: 28.487,
    y1: 19.9846,
    x2: 27.7925,
    y2: 21.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2969_39905",
    x1: 28.3913,
    y1: 14.6835,
    x2: 27.6977,
    y2: 16.1373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2969_39905",
    x1: 27.4858,
    y1: 14.5927,
    x2: 26.7922,
    y2: 16.0465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2969_39905",
    x1: 26.5916,
    y1: 14.7785,
    x2: 25.8985,
    y2: 16.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2969_39905",
    x1: 27.0163,
    y1: 15.4174,
    x2: 26.3226,
    y2: 16.8712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2969_39905",
    x1: 27.9286,
    y1: 15.3684,
    x2: 27.2341,
    y2: 16.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2969_39905",
    x1: 28.4115,
    y1: 16.0999,
    x2: 27.7184,
    y2: 17.5561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2969_39905",
    x1: 27.4652,
    y1: 16.114,
    x2: 26.7722,
    y2: 17.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2969_39905",
    x1: 26.8684,
    y1: 16.7861,
    x2: 26.1754,
    y2: 18.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2969_39905",
    x1: 26.4688,
    y1: 17.5897,
    x2: 25.7758,
    y2: 19.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2969_39905",
    x1: 27.4258,
    y1: 17.6094,
    x2: 26.7336,
    y2: 19.0641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2969_39905",
    x1: 29.3826,
    y1: 16.0934,
    x2: 28.6896,
    y2: 17.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2969_39905",
    x1: 29.8912,
    y1: 16.9199,
    x2: 29.199,
    y2: 18.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2969_39905",
    x1: 29.2429,
    y1: 17.7158,
    x2: 28.5492,
    y2: 19.1697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2969_39905",
    x1: 27.1982,
    y1: 18.3057,
    x2: 26.506,
    y2: 19.7604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2969_39905",
    x1: 27.8698,
    y1: 18.7397,
    x2: 27.1753,
    y2: 20.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2969_39905",
    x1: 28.8519,
    y1: 18.5159,
    x2: 28.1574,
    y2: 19.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2969_39905",
    x1: 30.0076,
    y1: 17.9008,
    x2: 29.3131,
    y2: 19.3561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2969_39905",
    x1: 29.6693,
    y1: 18.6692,
    x2: 28.9756,
    y2: 20.1231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2969_39905",
    x1: 29.0956,
    y1: 19.4299,
    x2: 28.4034,
    y2: 20.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2969_39905",
    x1: 29.9772,
    y1: 19.6098,
    x2: 29.2841,
    y2: 21.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2969_39905",
    x1: 30.4505,
    y1: 18.7574,
    x2: 29.7574,
    y2: 20.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2969_39905",
    x1: 28.3906,
    y1: 19.4094,
    x2: 27.696,
    y2: 20.8647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2969_39905",
    x1: 29.3462,
    y1: 20.2228,
    x2: 28.6516,
    y2: 21.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2969_39905",
    x1: 30.2372,
    y1: 20.4177,
    x2: 29.5442,
    y2: 21.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2969_39905",
    x1: 26.912,
    y1: 19.0922,
    x2: 26.219,
    y2: 20.5484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2969_39905",
    x1: 27.6145,
    y1: 19.5807,
    x2: 26.9208,
    y2: 21.0345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2969_39905",
    x1: 25.6243,
    y1: 17.6509,
    x2: 24.9313,
    y2: 19.1071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2969_39905",
    x1: 26.2832,
    y1: 18.3621,
    x2: 25.5887,
    y2: 19.8174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2969_39905",
    x1: 28.4306,
    y1: 17.108,
    x2: 27.7361,
    y2: 18.5634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2969_39905",
    x1: 26.0289,
    y1: 15.4104,
    x2: 25.3358,
    y2: 16.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2969_39905",
    x1: 26.4196,
    y1: 16.12,
    x2: 25.7251,
    y2: 17.5753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2969_39905",
    x1: 25.9143,
    y1: 16.8468,
    x2: 25.2221,
    y2: 18.3014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2969_39905",
    x1: 25.45,
    y1: 16.0919,
    x2: 24.7555,
    y2: 17.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2969_39905",
    x1: 28.9214,
    y1: 15.3193,
    x2: 28.2293,
    y2: 16.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2969_39905",
    x1: 29.0401,
    y1: 16.781,
    x2: 28.3464,
    y2: 18.2348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2969_39905",
    x1: 28.2724,
    y1: 17.9184,
    x2: 27.5779,
    y2: 19.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2969_39905",
    x1: 27.7674,
    y1: 16.867,
    x2: 27.0753,
    y2: 18.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2969_39905",
    x1: 32.3542,
    y1: 26.8957,
    x2: 33.314,
    y2: 31.9702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2969_39905",
    x1: 27.2391,
    y1: 27.5165,
    x2: 27.5376,
    y2: 29.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2969_39905",
    x1: 25.5629,
    y1: 29.1994,
    x2: 25.8614,
    y2: 30.7841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2969_39905",
    x1: 22.356,
    y1: 24.9764,
    x2: 22.6543,
    y2: 26.5594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2969_39905",
    x1: 21.5718,
    y1: 25.4377,
    x2: 21.872,
    y2: 27.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2969_39905",
    x1: 20.9597,
    y1: 26.1179,
    x2: 21.2597,
    y2: 27.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2969_39905",
    x1: 21.6791,
    y1: 26.3805,
    x2: 21.9792,
    y2: 27.9633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2969_39905",
    x1: 22.387,
    y1: 25.8044,
    x2: 22.6854,
    y2: 27.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2969_39905",
    x1: 23.2082,
    y1: 26.1086,
    x2: 23.5085,
    y2: 27.6931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2969_39905",
    x1: 22.4548,
    y1: 26.6781,
    x2: 22.7533,
    y2: 28.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2969_39905",
    x1: 22.3679,
    y1: 27.5723,
    x2: 22.6681,
    y2: 29.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2969_39905",
    x1: 22.52,
    y1: 28.4573,
    x2: 22.8203,
    y2: 30.0418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2969_39905",
    x1: 23.3039,
    y1: 27.9082,
    x2: 23.6039,
    y2: 29.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2969_39905",
    x1: 23.9885,
    y1: 25.5295,
    x2: 24.2887,
    y2: 27.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2969_39905",
    x1: 24.8869,
    y1: 25.8962,
    x2: 25.1869,
    y2: 27.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2969_39905",
    x1: 24.8335,
    y1: 26.9213,
    x2: 25.1318,
    y2: 28.5043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2969_39905",
    x1: 23.5311,
    y1: 28.6041,
    x2: 23.8311,
    y2: 30.1869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2969_39905",
    x1: 24.3293,
    y1: 28.5582,
    x2: 24.6279,
    y2: 30.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2969_39905",
    x1: 24.9899,
    y1: 27.7981,
    x2: 25.2885,
    y2: 29.3828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2969_39905",
    x1: 25.5601,
    y1: 26.6193,
    x2: 25.8586,
    y2: 28.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2969_39905",
    x1: 25.7405,
    y1: 27.4394,
    x2: 26.0388,
    y2: 29.0223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2969_39905",
    x1: 25.7266,
    y1: 28.392,
    x2: 26.0266,
    y2: 29.9748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2969_39905",
    x1: 26.5441,
    y1: 28.0164,
    x2: 26.8443,
    y2: 29.6009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2969_39905",
    x1: 26.4231,
    y1: 27.0497,
    x2: 26.7233,
    y2: 28.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2969_39905",
    x1: 25.1453,
    y1: 28.7916,
    x2: 25.4455,
    y2: 30.3761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2969_39905",
    x1: 26.3968,
    y1: 28.8845,
    x2: 26.6953,
    y2: 30.4692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2969_39905",
    x1: 27.2309,
    y1: 28.5149,
    x2: 27.5311,
    y2: 30.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2969_39905",
    x1: 23.7649,
    y1: 29.4083,
    x2: 24.0651,
    y2: 30.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2969_39905",
    x1: 24.62,
    y1: 29.3881,
    x2: 24.9183,
    y2: 30.9711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2969_39905",
    x1: 21.8745,
    y1: 29.0056,
    x2: 22.1747,
    y2: 30.5901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2969_39905",
    x1: 22.8261,
    y1: 29.1901,
    x2: 23.1247,
    y2: 30.7748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2969_39905",
    x1: 23.8187,
    y1: 26.9095,
    x2: 24.1172,
    y2: 28.4942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2969_39905",
    x1: 20.8781,
    y1: 26.9582,
    x2: 21.1784,
    y2: 28.5427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2969_39905",
    x1: 21.6126,
    y1: 27.3003,
    x2: 21.9112,
    y2: 28.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2969_39905",
    x1: 21.6352,
    y1: 28.1841,
    x2: 21.9335,
    y2: 29.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2969_39905",
    x1: 20.8133,
    y1: 27.8499,
    x2: 21.1136,
    y2: 29.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2969_39905",
    x1: 23.1594,
    y1: 25.1769,
    x2: 23.4596,
    y2: 26.7614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2969_39905",
    x1: 24.1177,
    y1: 26.2867,
    x2: 24.416,
    y2: 27.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2969_39905",
    x1: 24.17,
    y1: 27.6583,
    x2: 24.4685,
    y2: 29.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2969_39905",
    x1: 23.1413,
    y1: 27.1071,
    x2: 23.4413,
    y2: 28.6899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2969_39905",
    x1: 30.7666,
    y1: 39.195,
    x2: 32.0049,
    y2: 40.2282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2969_39905",
    x1: 29.7517,
    y1: 39.5382,
    x2: 30.9888,
    y2: 40.5726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2969_39905",
    x1: 33.4396,
    y1: 33.671,
    x2: 39.7457,
    y2: 33.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2969_39905",
    x1: 33.1403,
    y1: 35.256,
    x2: 34.3785,
    y2: 36.2892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2969_39905",
    x1: 32.9147,
    y1: 37.6204,
    x2: 34.153,
    y2: 38.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2969_39905",
    x1: 27.7544,
    y1: 36.3947,
    x2: 28.9927,
    y2: 37.4279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2969_39905",
    x1: 27.4427,
    y1: 37.2499,
    x2: 28.6797,
    y2: 38.2819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2969_39905",
    x1: 27.4008,
    y1: 38.1622,
    x2: 28.639,
    y2: 39.1954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2969_39905",
    x1: 28.1246,
    y1: 37.9096,
    x2: 29.3616,
    y2: 38.9416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2969_39905",
    x1: 28.3041,
    y1: 37.0138,
    x2: 29.5412,
    y2: 38.0482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2969_39905",
    x1: 29.1336,
    y1: 36.7269,
    x2: 30.3707,
    y2: 37.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2969_39905",
    x1: 28.9124,
    y1: 37.6468,
    x2: 30.1495,
    y2: 38.6812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2969_39905",
    x1: 29.4145,
    y1: 38.3913,
    x2: 30.6516,
    y2: 39.4257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2969_39905",
    x1: 30.0944,
    y1: 38.9792,
    x2: 31.3315,
    y2: 40.0136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2969_39905",
    x1: 30.381,
    y1: 38.0454,
    x2: 31.6168,
    y2: 39.0787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2969_39905",
    x1: 29.3678,
    y1: 35.7865,
    x2: 30.606,
    y2: 36.8197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2969_39905",
    x1: 30.2947,
    y1: 35.4986,
    x2: 31.5317,
    y2: 36.5306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2969_39905",
    x1: 30.9047,
    y1: 36.3244,
    x2: 32.1417,
    y2: 37.3564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2969_39905",
    x1: 30.9686,
    y1: 38.4503,
    x2: 32.2044,
    y2: 39.4835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2969_39905",
    x1: 31.5041,
    y1: 37.9322,
    x2: 32.7411,
    y2: 38.9642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2969_39905",
    x1: 31.5819,
    y1: 36.9018,
    x2: 32.8201,
    y2: 37.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2969_39905",
    x1: 31.2741,
    y1: 35.6293,
    x2: 32.5112,
    y2: 36.6637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2969_39905",
    x1: 31.934,
    y1: 36.1481,
    x2: 33.171,
    y2: 37.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2969_39905",
    x1: 32.5282,
    y1: 36.893,
    x2: 33.7652,
    y2: 37.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2969_39905",
    x1: 32.9226,
    y1: 36.0825,
    x2: 34.1597,
    y2: 37.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2969_39905",
    x1: 32.2148,
    y1: 35.412,
    x2: 33.4519,
    y2: 36.4465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2969_39905",
    x1: 32.3331,
    y1: 37.5706,
    x2: 33.5713,
    y2: 38.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2969_39905",
    x1: 33.3585,
    y1: 36.8472,
    x2: 34.5967,
    y2: 37.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2969_39905",
    x1: 33.9691,
    y1: 34.8477,
    x2: 35.2074,
    y2: 35.8808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2969_39905",
    x1: 34.4576,
    y1: 35.4471,
    x2: 35.6947,
    y2: 36.4815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2969_39905",
    x1: 34.193,
    y1: 36.5577,
    x2: 35.4288,
    y2: 37.5909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2969_39905",
    x1: 35.3201,
    y1: 35.12,
    x2: 36.5571,
    y2: 36.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2969_39905",
    x1: 34.8791,
    y1: 35.903,
    x2: 36.1161,
    y2: 36.9374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2969_39905",
    x1: 33.8614,
    y1: 37.3989,
    x2: 35.0984,
    y2: 38.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2969_39905",
    x1: 34.8557,
    y1: 34.5504,
    x2: 36.0939,
    y2: 35.5836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2969_39905",
    x1: 35.5989,
    y1: 34.1645,
    x2: 36.8371,
    y2: 35.1977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2969_39905",
    x1: 31.6587,
    y1: 38.924,
    x2: 32.897,
    y2: 39.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2969_39905",
    x1: 32.3063,
    y1: 38.3652,
    x2: 33.5433,
    y2: 39.3972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2969_39905",
    x1: 27.4838,
    y1: 39.298,
    x2: 28.7208,
    y2: 40.3324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2969_39905",
    x1: 30.1136,
    y1: 36.9596,
    x2: 31.3519,
    y2: 37.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2969_39905",
    x1: 27.8727,
    y1: 38.8648,
    x2: 29.1109,
    y2: 39.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2969_39905",
    x1: 28.6573,
    y1: 38.6628,
    x2: 29.8944,
    y2: 39.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2969_39905",
    x1: 29.2362,
    y1: 39.3311,
    x2: 30.472,
    y2: 40.3643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2969_39905",
    x1: 28.3889,
    y1: 39.5951,
    x2: 29.6271,
    y2: 40.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2969_39905",
    x1: 28.5045,
    y1: 36.0391,
    x2: 29.7403,
    y2: 37.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2969_39905",
    x1: 29.9472,
    y1: 36.2873,
    x2: 31.1854,
    y2: 37.3205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2969_39905",
    x1: 30.86,
    y1: 37.3148,
    x2: 32.097,
    y2: 38.3492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2969_39905",
    x1: 29.7155,
    y1: 37.5425,
    x2: 30.9525,
    y2: 38.5745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2969_39905",
    x1: 33.7755,
    y1: 35.8906,
    x2: 35.0125,
    y2: 36.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2969_39905",
    x1: 31.8808,
    y1: 33.1147,
    x2: 37.877,
    y2: 30.4389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2969_39905",
    x1: 30.4255,
    y1: 30.396,
    x2: 31.3568,
    y2: 31.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2969_39905",
    x1: 27.7964,
    y1: 34.4175,
    x2: 28.7268,
    y2: 35.7325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2969_39905",
    x1: 31.111,
    y1: 31.0582,
    x2: 32.0414,
    y2: 32.3731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2969_39905",
    x1: 30.2872,
    y1: 33.2847,
    x2: 31.22,
    y2: 34.6002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2969_39905",
    x1: 25.6131,
    y1: 30.7804,
    x2: 26.545,
    y2: 32.0944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2969_39905",
    x1: 25.0921,
    y1: 31.5268,
    x2: 26.0249,
    y2: 32.8423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2969_39905",
    x1: 24.819,
    y1: 32.3998,
    x2: 25.7509,
    y2: 33.7138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2969_39905",
    x1: 25.5823,
    y1: 32.3392,
    x2: 26.5151,
    y2: 33.6547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2969_39905",
    x1: 25.986,
    y1: 31.5208,
    x2: 26.9164,
    y2: 32.8358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2969_39905",
    x1: 26.8614,
    y1: 31.455,
    x2: 27.7918,
    y2: 32.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2969_39905",
    x1: 26.4122,
    y1: 32.2881,
    x2: 27.3426,
    y2: 33.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2969_39905",
    x1: 26.7062,
    y1: 33.135,
    x2: 27.6376,
    y2: 34.4514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2969_39905",
    x1: 27.2133,
    y1: 33.8769,
    x2: 28.1446,
    y2: 35.1933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2969_39905",
    x1: 27.7292,
    y1: 33.047,
    x2: 28.6606,
    y2: 34.3634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2969_39905",
    x1: 27.3285,
    y1: 30.6051,
    x2: 28.2604,
    y2: 31.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2969_39905",
    x1: 28.297,
    y1: 30.5629,
    x2: 29.2298,
    y2: 31.8784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2969_39905",
    x1: 28.6754,
    y1: 31.5173,
    x2: 29.6082,
    y2: 32.8328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2969_39905",
    x1: 28.1935,
    y1: 33.5892,
    x2: 29.1248,
    y2: 34.9056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2969_39905",
    x1: 28.844,
    y1: 33.2246,
    x2: 29.7768,
    y2: 34.5401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2969_39905",
    x1: 29.1826,
    y1: 32.2487,
    x2: 30.1154,
    y2: 33.5642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2969_39905",
    x1: 29.2104,
    y1: 30.9404,
    x2: 30.1417,
    y2: 32.2568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2969_39905",
    x1: 29.7155,
    y1: 31.6107,
    x2: 30.6469,
    y2: 32.9271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2969_39905",
    x1: 30.0998,
    y1: 32.4829,
    x2: 31.0326,
    y2: 33.7985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2969_39905",
    x1: 30.6881,
    y1: 31.7997,
    x2: 31.6194,
    y2: 33.1161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2969_39905",
    x1: 30.1755,
    y1: 30.971,
    x2: 31.1068,
    y2: 32.2874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2969_39905",
    x1: 29.3773,
    y1: 30.2905,
    x2: 30.3101,
    y2: 31.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2969_39905",
    x1: 31.5299,
    y1: 30.307,
    x2: 32.4627,
    y2: 31.6225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2969_39905",
    x1: 29.7378,
    y1: 33.0878,
    x2: 30.6706,
    y2: 34.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2969_39905",
    x1: 30.9149,
    y1: 32.6525,
    x2: 31.8453,
    y2: 33.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2969_39905",
    x1: 32.0167,
    y1: 30.8751,
    x2: 32.9472,
    y2: 32.1901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2969_39905",
    x1: 32.3355,
    y1: 31.5798,
    x2: 33.266,
    y2: 32.8948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2969_39905",
    x1: 31.7949,
    y1: 32.5842,
    x2: 32.7262,
    y2: 33.9006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2969_39905",
    x1: 33.2164,
    y1: 31.6824,
    x2: 34.1492,
    y2: 32.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2969_39905",
    x1: 32.6246,
    y1: 32.4058,
    x2: 33.5559,
    y2: 33.7222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2969_39905",
    x1: 31.2591,
    y1: 33.3128,
    x2: 32.1919,
    y2: 34.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2969_39905",
    x1: 32.949,
    y1: 30.8128,
    x2: 33.8818,
    y2: 32.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2969_39905",
    x1: 33.8871,
    y1: 30.963,
    x2: 34.8184,
    y2: 32.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2969_39905",
    x1: 28.7395,
    y1: 34.2242,
    x2: 29.6723,
    y2: 35.5397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2969_39905",
    x1: 29.5085,
    y1: 33.8493,
    x2: 30.4404,
    y2: 35.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2969_39905",
    x1: 26.8537,
    y1: 34.6455,
    x2: 27.7856,
    y2: 35.9595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2969_39905",
    x1: 27.7482,
    y1: 31.929,
    x2: 28.681,
    y2: 33.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2969_39905",
    x1: 25.0957,
    y1: 33.1994,
    x2: 26.0275,
    y2: 34.5135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2969_39905",
    x1: 25.9059,
    y1: 33.2044,
    x2: 26.8377,
    y2: 34.5184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2969_39905",
    x1: 26.2935,
    y1: 33.9973,
    x2: 27.2239,
    y2: 35.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2969_39905",
    x1: 25.4071,
    y1: 34.0354,
    x2: 26.3399,
    y2: 35.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2969_39905",
    x1: 26.4282,
    y1: 30.6272,
    x2: 27.3595,
    y2: 31.9436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2969_39905",
    x1: 27.7602,
    y1: 31.2381,
    x2: 28.6921,
    y2: 32.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2969_39905",
    x1: 28.3798,
    y1: 32.4652,
    x2: 29.3103,
    y2: 33.7802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2969_39905",
    x1: 27.2143,
    y1: 32.3913,
    x2: 28.1471,
    y2: 33.7068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2969_39905",
    x1: 31.5619,
    y1: 31.8322,
    x2: 32.4947,
    y2: 33.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2969_39905",
    x1: 38.8845,
    y1: 29.564,
    x2: 43.912,
    y2: 29.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2969_39905",
    x1: 38.6185,
    y1: 29.5582,
    x2: 47.7229,
    y2: 29.6131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5295F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmri);
export default __webpack_public_path__ + "static/media/bmri.14929e698ab4445850a9363d30d61274.svg";
export { ForwardRef as ReactComponent };